import React, { useState, useRef, useEffect } from "react";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import { useLocation, useNavigate } from "react-router-dom";
import * as TRFListRegistrationService from "../../Services/B2BRegistration/TRFListRegistrationService";
import toast, { Toaster } from "react-hot-toast";
import * as moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaFlask, FaInfoCircle, FaSearch, FaSpinner, FaEye, FaPaperPlane, FaSyncAlt, FaSave, FaCheckCircle, FaToggleOn, FaToggleOff, FaPen, FaTrash, FaTimesCircle, FaUser, FaFileAlt, FaClipboardList, FaPlus, FaExclamationTriangle } from "react-icons/fa";
import { Calendar, Eye } from "lucide-react";
import * as CommonVariables from '../../Common/CommonVariables'
import Popover from '../../Common/Popper';
import * as B2BRegistrationService from "../../Services/B2BRegistration/B2BRegistrationService";
import * as PartnerService from "../../Services/Partner/PartnerService";
import CommonPagination from "../../Common/CommonPagination";
import { format, parseISO } from "date-fns";
import PatientTestDetailsModalComponent from "../PatientVisit/PatientTestDetailsModalComponent";
import { store } from "../../Store/store";
import { useSelector } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";
import "./TRFRegistrationListComponent.css"
import TestHistoryModalComponent from "./TestHistoryModalComponent"
import PendingAttributesModalComponent from "./PendingAttributesModalComponent"
import Swal from "sweetalert2";


const TRFRegistrationListComponent = () => {
    const navigate = useNavigate();

    const userInfo = store.getState();
    const userDetails = userInfo?.userData;

    const [filteredB2BTRFRegistrationtList, setFilteredB2BTRFRegistrationtList] = useState([]);
    const [b2bTRFRegistrationDetails, setB2BTRFRegistrationDetails] = useState([]);
    const [selectedTest, setSelectedTest] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [showAttachments, setShowAttachments] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [selectedPendingRegistration, setSelectedPendingRegistration] = useState(null);
    const [showPendingAttributesModal, setShowPendingAttributesModal] = useState(false);
    const [pendingHistoryFields, setPendingHistoryFields] = useState([]);
    const [loadingPendingHistory, setLoadingPendingHistory] = useState(false);
    const [savingPendingAttributes, setSavingPendingAttributes] = useState(false);
    const [isUploadingForPendingHistory, setIsUploadingForPendingHistory] = useState(false);
    const pendingFileInputRefs = useRef([]);
    const [historyModalFields, setHistoryModalFields] = useState([]);
    const [savingHistoryModal, setSavingHistoryModal] = useState(false);
    const [isUploadingForHistoryModal, setIsUploadingForHistoryModal] = useState(false);
    const historyFileInputRefs = useRef([]);
    const [orgLocationList, setOrgLocationList] = useState([]);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [SearchLoading, setSearchLoading] = useState(false);
    const [dateRangeOption, setDateRangeOption] = useState('Today');
    const [showPatientTestDetails, setShowPatientTestDetails] = useState(false);
    const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
    const [patient, setPatient] = useState({});
    const [visit, setVisit] = useState({});
    const [samples, setSamples] = useState([]);
    const [tests, setTests] = useState([]);
    const [reportURL, setReportURL] = useState("");
    const [reportWOSURL, setReportWOSURL] = useState("");
    const [visitStatus, setVisitStatus] = useState("");
    const [crmVisitDetails, setCRMVisitDetails] = useState([]);
    const [showPatientTestTATModal, setshowPatientTestTATModal] = useState(false);
    const [trflist, setTrflist] = useState([]);
    const [showBatchSheetModal, setShowBatchSheetModal] = useState(false);
    const [batchSheetData, setBatchSheetData] = useState([]);
    const [batchSheetLoading, setBatchSheetLoading] = useState(false);
    const [batchSheetSearch, setBatchSheetSearch] = useState("");
    const [batchSheetPage, setBatchSheetPage] = useState(1);


    const orgId = useSelector((state) => state.selectedOrganization);
    const clientCode = useSelector((state) => state.Partner_Account_Details?.MHL_Client_Code__c);


    const accountDetails = useSelector((state) => state.Partner_Account_Details);

    const selectedSearchPR = useRef()

    const location = useLocation();
    const [initDone, setInitDone] = useState(false);


    const GetPatientTestDetailTAT = (data) => {

        setSearchLoading(true);
        setCRMVisitDetails(data);
        PartnerService.GetPatientTestsDetailsByVID(data.Vid, orgId.MHL_Org_Id__c)
            .then(({ data }) => {
                //debugger;
                //console.log("PatientTest API response:", data);
                if (data.IsSuccess) {
                    setshowPatientTestTATModal(true);
                    const response = data.Data;

                    setPatient(response.PatientDemographics || {});
                    setVisit(response.PatientVisitDetails || {});
                    setSamples(response.SampleInfoList || []);
                    setTests(response.TestOrderDetails || []);
                    setReportURL(response.ReportS3URL || "");
                    setReportWOSURL(response.ReportWOSS3URL || "");
                    setVisitStatus(response.VisitStatus || "");

                    // setPatientReportList(data.Data);
                }
                else {
                    // setPatientReportList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
        // setTestDetailsbyVID(data.MHL_Test_Details_List);
    }

    useEffect(() => {
        if (orgId) {
            fetchB2BTRFRegistrationListData();
            setSelectedTRFPDFArrayList([]);
            B2BRegistrationService.GetOrgLocationListByOrgId(orgId.MHL_Org_Id__c)
                .then(({ data }) => {
                    if (data.IsSuccess) setOrgLocationList(data.Data || []);
                })
                .catch(() => { });
        }
    }, [orgId]);


    useEffect(() => {
        if (!initDone && location.state) {
            const { startDate: passedStartDate, endDate: passedEndDate, dateRangeOption: passedOption } = location.state;

            if (passedStartDate && endDate) {
                setDateRangeOption(passedOption || 'Custom');
                setStartDate(new Date(passedStartDate));
                setEndDate(new Date(passedEndDate));
                setInitDone(true); // Prevents re-running this logic
            }
        }
    }, [location.state, initDone]);

    useEffect(() => {
        if (initDone && startDate && endDate) {
            fetchB2BTRFRegistrationListData();
        }
    }, [initDone, startDate, endDate, dateRangeOption]);


    useEffect(() => {
        if (startDate && endDate) {
            fetchB2BTRFRegistrationListData();
        }
    }, [dateRangeOption]);

    const validateDateRange = (startDateValue, endDateValue) => {
        if (!startDateValue || !endDateValue) {
            toast.error("Please select a date range");
            return false;
        }
        if (startDateValue > endDateValue) {
            toast.error("Start date cannot be after end date");
            return false;
        }
        if (endDateValue > new Date()) {
            toast.error("End date cannot be in the future");
            return false;
        }
        return true;
    };

    const handleReportDownload = async (reportURL) => {

        const requestUrl = `${CommonVariables.API_DOMAIN}Account/Download?url=${encodeURIComponent(reportURL)}`;

        try {
            const response = await trackPromise(
                axios.get(requestUrl, CommonVariables.API_HEADER)
            );

            const fileUrl = response.data.Data; // assuming the API returns a direct URL to open
            if (fileUrl) {
                window.open(fileUrl, '_blank');
            } else {
                toast.error('File URL is empty.');
            }

        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Download failed.');
        }
    };

    const formatDate = (date, isEnd = false) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        if (isEnd) {
            return `${year}-${month}-${day}T23:59:59`;
        }
        return `${year}-${month}-${day}T00:00:00`;
    };

    const fetchB2BTRFRegistrationListData = () => {
        setFilteredB2BTRFRegistrationtList([]);
        // if (!validateDateRange(startDate, endDate)) return;

        if (dateRangeOption === "Custom") {
            if (!startDate || !endDate) {
                toast.error("Please select both Start Date and End Date for Custom range");
                return;
            }
        }

        setSearchLoading(true);
        setLoading(true);
        //debugger;

        const payload = {
            ClientCode: clientCode,
            OrgId: parseInt(orgId?.MHL_Org_Id__c),
            StartDate: formatDate(startDate),
            EndDate: formatDate(endDate, true)
        }

        TRFListRegistrationService.GetB2BTRFRegistrationListData(payload)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //console.log(data.Data);
                    setFilteredB2BTRFRegistrationtList(data.Data);
                } else {
                    setFilteredB2BTRFRegistrationtList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setLoading(false);
                setSearchLoading(false);
            });
    };

    const fetchUniversalFilterTRFListData = () => {
        if (!orgId) {
            setFilteredB2BTRFRegistrationtList([])
            return;
        }

        if (selectedSearchPR.current.value == null || selectedSearchPR.current.value == "") {
            // window.location.reload();
            toast.error("Please enter search data.")
            return;
        }
        // setLoading(true);
        setSearchLoading(true);
        TRFListRegistrationService.GetUniversalB2BTRFRegistrationDataList(selectedSearchPR.current.value, clientCode)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setFilteredB2BTRFRegistrationtList(data.Data);
                }
                else {
                    setFilteredB2BTRFRegistrationtList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }

    const [editingSampleIndex, setEditingSampleIndex] = useState(null);
    const [selectedSampleStatus, setSelectedSampleStatus] = useState("");

    const handleEditSample = (index, currentStatus) => {
        setEditingSampleIndex(index);
        setSelectedSampleStatus(currentStatus || "Collected");
    };

    const handleStatusChange = (value) => {
        setSelectedSampleStatus(value);
    };

    const handleSaveSampleStatus = async (sample, rowIndex) => {
        const vid = b2bTRFRegistrationDetails?.Vid;
        if (!vid) {
            toast.error("VID not available for this registration.");
            return;
        }

        let preBarcode = "";

        // Validate only when the partner is enabled AND the toggle is ON
        if (isPreprintedEnabled) {
            const result = await validatePreprintedBarcodeForSample(sample, rowIndex);
            if (!result.ok) return;
            preBarcode = result.preBarcode;
        }

        const statusConfig =
            SAMPLE_STATUS_CONFIG[selectedSampleStatus] || DEFAULT_STATUS_CONFIG;

        const payload = {
            vid: vid,
            sampleDetails: [
                {
                    barcode: sample.Ref_BarcodeNo || "",
                    preBarcode: preBarcode,
                    sampleContainer: sample.Container_Name || "",
                    sampleType: sample.Sample_Name || "",
                    statuscode: statusConfig.statuscode,
                    status: selectedSampleStatus,
                    reasoncode: statusConfig.reasoncode,
                    reason: statusConfig.reason,
                },
            ],
        };

        setSavingSampleStatus(true);
        try {
            const { data } = await TRFListRegistrationService.UpdateRecollectSample(payload);
            if (data?.IsSuccess) {
                toast.success("Sample status updated successfully.");
                setEditingSampleIndex(null);
                GetB2BTRFRegistrationDetailByTRFId(b2bTRFRegistrationDetails.Reg_Trf_Id);
            } else {
                toast.error(data?.ResponseMessage || "Failed to update sample status.");
            }
        } catch {
            toast.error("Something went wrong.");
        } finally {
            setSavingSampleStatus(false);
        }
    };


    const GetB2BTRFRegistrationDetailByTRFId = (trfId) => {
        //debugger;
        // setLoading(true);
        setSearchLoading(true);
        TRFListRegistrationService.GetB2BTRFRegistrationDetailByTRFId(trfId)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    //console.log(data.Data);
                    setB2BTRFRegistrationDetails(data.Data);
                    setShowPreview(true);

                    //NEW 
                    setSamplePreBarcodes({});
                    setEditingSampleIndex(null);
                    setPreprintedAllowedForTRF(true);
                }
                else {
                    setB2BTRFRegistrationDetails([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }

    const RepushFailedRegistration = (trfId) => {
        //debugger;
        // setLoading(true);
        setSearchLoading(true);
        TRFListRegistrationService.RepushFailedRegistration(trfId)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    fetchB2BTRFRegistrationListData();
                    // setShowPreview(true);
                    toast.success(data.ResponseMessage)
                }
                else {
                    // setB2BTRFRegistrationDetails([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }


    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15); // Set number of items per page

    // Pagination logic
    const indexOfLastTRF = currentPage * itemsPerPage;
    const indexOfFirstTRF = indexOfLastTRF - itemsPerPage;
    const currentfilteredB2BTRFRegistrationtList = filteredB2BTRFRegistrationtList.slice(indexOfFirstTRF, indexOfLastTRF);

    const handleAttachmentDownload = (url) => {
        if (!url) {
            toast.error("No file URL provided.");
            return;
        }
        B2BRegistrationService.View_UploadedFile(url)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //debugger;
                    // window.open(data.Data, '_blank');
                    const newWindow = window.open(data.Data, "_blank");
                    if (newWindow) {
                        newWindow.focus();
                        newWindow.print();
                    }
                } else {
                    toast.error("Failed to download file.");
                }
            })
            .catch(() => toast.error("Something went wrong while downloading."));
    };

    const handleDateRangeChange = (e) => {
        const selected = e.target.value;
        setDateRangeOption(selected);

        const today = new Date();
        let start = null;
        let end = null;

        const startOfDay = (date) => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            return d;
        };

        const endOfDay = (date) => {
            const d = new Date(date);
            d.setHours(23, 59, 59, 999);
            return d;
        };

        switch (selected) {
            case 'Today':
                start = startOfDay(today);
                end = endOfDay(today);
                break;
            case 'Yesterday':
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                start = startOfDay(yesterday);
                end = endOfDay(yesterday);
                break;
            case 'Current Week':
                const dayOfWeek = today.getDay(); // 0 = Sunday
                start = startOfDay(new Date(today));
                start.setDate(today.getDate() - dayOfWeek);
                end = endOfDay(today);
                break;
            case 'Last 7 Days':
                start = startOfDay(new Date(today));
                start.setDate(today.getDate() - 6); // includes today
                end = endOfDay(today);
                break;
            case 'MTD':
                start = startOfDay(new Date(today.getFullYear(), today.getMonth(), 1));
                end = endOfDay(today);
                break;
            case 'Last 30 Days':
                start = startOfDay(new Date(today));
                start.setDate(today.getDate() - 29); // last 30 days including today
                end = endOfDay(today);
                break;
            case 'Custom':
                start = startDate;
                end = endDate;
                break;
            default:
                break;
        }

        setStartDate(start);
        setEndDate(end);
    };


    const calculateAge = (dob) => {
        if (!dob) return "-";

        const birthDate = new Date(dob);
        const today = new Date();

        let years = today.getFullYear() - birthDate.getFullYear();
        let months = today.getMonth() - birthDate.getMonth();
        let days = today.getDate() - birthDate.getDate();

        // Adjust if negative
        if (days < 0) {
            months--;
            const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
            days += prevMonth;
        }
        if (months < 0) {
            years--;
            months += 12;
        }

        // Convert everything into total days for flexibility
        const diffTime = today - birthDate;
        const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const totalMonths = years * 12 + months;

        // Logic
        if (years >= 2) {
            return `${years} Year${years > 1 ? "s" : ""}`;
        } else if (years >= 1) {
            // show year with decimal (e.g. 1.6 Year)
            const decimalYear = (totalMonths / 12).toFixed(1);
            return `${decimalYear} Year`;
        } else if (totalMonths >= 1) {
            return `${totalMonths} Month${totalMonths > 1 ? "s" : ""}`;
        } else if (totalDays >= 7) {
            const weeks = Math.floor(totalDays / 7);
            const remDays = totalDays % 7;
            return `${weeks} Week${weeks > 1 ? "s" : ""}${remDays > 0 ? ` ${remDays} Day${remDays > 1 ? "s" : ""}` : ""}`;
        } else {
            return `${totalDays} Day${totalDays > 1 ? "s" : ""}`;
        }
    };


    const buildHistoryModalFields = (test) => {
        return (test.History_Attributes || []).map(att => {
            const attachments = att.HistoryAttachments || [];

            let selectedDateTime = "";
            if (att.History_Attribute === "DateTime" && att.History_Value) {
                const d = new Date(att.History_Value);
                if (!isNaN(d.getTime())) {
                    selectedDateTime = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
                }
            }

            let isPrefilled = false;
            if (att.History_Attribute === "Attachement") {
                if (att.Is_UploadAllAttachments) {
                    isPrefilled = (att.OptionsList || []).every(opt =>
                        attachments.some(a => a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase())
                    );
                } else {
                    isPrefilled = attachments.length >= 1;
                }
            } else {
                isPrefilled = !!att.History_Value;
            }

            return {
                Patient_Test_Id: test.Patient_Test_Id,
                History_Attribute_Id: att.History_Attribute_Id,
                Test_History_Attribute_Id: att.Test_History_Attribute_Id,
                Test_History_Id: att.Test_History_Id,
                History_Attribute: att.History_Attribute,
                History_Name: att.History_Name,
                Is_Mandatory: att.Is_Mandatory || false,
                Options: att.OptionsList || [],
                Is_UploadAllAttachments: att.Is_UploadAllAttachments || false,
                History_Value: att.History_Value || "",
                HistoryAttachments: attachments.map(a => ({ ...a, isNew: false })),
                Urn_File_Path: att.Urn_File_Path || "",
                Urn_File_Type_Id: "",
                Urn_File_Type: att.Urn_File_Type || "",
                Urn_Of: "",
                Urn_Number: att.Urn_Number || "",
                History_Attribute_Category: att.history_attribute_category || "",
                PatientNumber: b2bTRFRegistrationDetails?.Pid || "",
                VisitNumber: b2bTRFRegistrationDetails?.Vid || "",
                OrgId: b2bTRFRegistrationDetails?.Org_Id || 0,
                VID: b2bTRFRegistrationDetails?.Vid || "",
                TestCode: att.Test_Code || test.Test_Code || "",
                TestName: test.Test_Name || "",
                selectedDateTime,
                selectedOption: att.History_Attribute === "DropDown" ? (att.History_Value || "") : "",
                _testName: test.Test_Name,
                _testCode: test.Test_Code,
                _isPrefilled: isPrefilled,
            };
        });
    };

    const handlePendingAttributesClick = async (item) => {

        setSelectedTest(null);
        setSelectedPendingRegistration(item);
        setLoadingPendingHistory(true);
        setShowPendingAttributesModal(true);

        try {

            const { data } =
                await TRFListRegistrationService
                    .GetHistoryAttributesByTRFId(item.Reg_Trf_Id);

            if (!data.IsSuccess) {
                toast.error("Failed to load history attributes.");
                setPendingHistoryFields([]);
                return;
            }

            const flat = [];

            (data.Data || []).forEach(test => {

                (test.History_Attributes || []).forEach(att => {

                    const attachments = att.HistoryAttachments || [];

                    let selectedDateTime = "";
                    if (att.History_Attribute === "DateTime" && att.History_Value) {
                        const d = new Date(att.History_Value);
                        if (!isNaN(d.getTime())) {
                            selectedDateTime =
                                `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")
                                }-${String(d.getDate()).padStart(2, "0")
                                }T${String(d.getHours()).padStart(2, "0")
                                }:${String(d.getMinutes()).padStart(2, "0")
                                }`;
                        }
                    }

                    let isPrefilled = false;
                    if (att.History_Attribute === "Attachement") {
                        if (att.Is_UploadAllAttachments) {
                            isPrefilled = (att.OptionsList || []).every(opt =>
                                attachments.some(a =>
                                    a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase()
                                )
                            );
                        } else {
                            isPrefilled = attachments.length >= 1;
                        }
                    } else {
                        isPrefilled = !!att.History_Value;
                    }

                    flat.push({
                        Patient_Test_Id: test.Patient_Test_Id,
                        History_Attribute_Id: att.History_Attribute_Id,
                        Test_History_Attribute_Id: att.Test_History_Attribute_Id,
                        Test_History_Id: att.Test_History_Id,
                        History_Attribute: att.History_Attribute,
                        History_Name: att.History_Name,
                        Is_Mandatory: att.Is_Mandatory || false,
                        Options: att.OptionsList || [],
                        Is_UploadAllAttachments: att.Is_UploadAllAttachments || false,
                        History_Value: att.History_Value || "",
                        HistoryAttachments: attachments.map(a => ({ ...a, isNew: false })),
                        Urn_File_Path: att.Urn_File_Path || "",
                        Urn_File_Type_Id: "",
                        Urn_File_Type: att.Urn_File_Type || "",
                        Urn_Of: "",
                        Urn_Number: att.Urn_Number || "",
                        History_Attribute_Category: att.history_attribute_category || "",
                        PatientNumber: item?.Pid || "",
                        VisitNumber: item?.Vid || "",
                        OrgId: item?.Org_Id || 0,
                        VID: item?.Vid || "",
                        TestCode: att.Test_Code || test.Test_Code || "",
                        TestName: test.Test_Name || "",
                        selectedDateTime,
                        selectedOption: att.History_Attribute === "DropDown"
                            ? (att.History_Value || "")
                            : "",
                        _testName: test.Test_Name,
                        _testCode: test.Test_Code,
                        _isPrefilled: isPrefilled
                    });

                });
            });

            setPendingHistoryFields(flat);

        } catch (err) {

            console.error(err);
            toast.error("Something went wrong.");
            setPendingHistoryFields([]);

        } finally {
            setLoadingPendingHistory(false);
        }
    };

    const validatePendingFile = (file, maxSizeMB = 10) => {
        if (!file) return { isValid: false, error: "No file selected." };
        const allowedExtensions = [".jpg", ".jpeg", ".bitmap", ".pdf", ".doc", ".docx", ".tiff", ".msg", ".eml", ".zip"];
        const fileName = file.name.toLowerCase();
        const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
        if (!isValidExtension) return { isValid: false, error: "Invalid file type. Allowed: JPG, JPEG, BITMAP, PDF, DOC, DOCX, TIFF, MSG, EML, ZIP" };
        const maxSize = maxSizeMB * 1024 * 1024;
        if (file.size > maxSize) return { isValid: false, error: `File size must be less than ${maxSizeMB} MB.` };
        return { isValid: true };
    };

    const updatePendingField = (patch, index) => {
        const updated = [...pendingHistoryFields];
        updated[index] = { ...updated[index], ...patch };
        setPendingHistoryFields(updated);
    };

    const handlePendingHistoryAttachFile = (index) => {
        const field = pendingHistoryFields[index];
        const { urnFileType, selectedHistoryFile } = field;
        setIsUploadingForPendingHistory(true);
        if (!selectedHistoryFile) {
            toast.error("Please select a file to upload.");
            setIsUploadingForPendingHistory(false);
            return;
        }
        const { isValid, error } = validatePendingFile(selectedHistoryFile);
        if (!isValid) {
            toast.error(error);
            setIsUploadingForPendingHistory(false);
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedHistoryFile);
        B2BRegistrationService.UploadAttachment(formData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const updated = [...pendingHistoryFields];
                    updated[index] = {
                        ...field,
                        urnFileType,
                        selectedHistoryFile: null,
                        History_Value: data.Data,
                        Urn_File_Path: data.Data,
                        HistoryAttachments: [
                            ...(field.HistoryAttachments || []),
                            { filePath: data.Data, fileType: urnFileType, fileTypeId: field.urnFileTypeId || null, isNew: true }
                        ]
                    };
                    setPendingHistoryFields(updated);
                    toast.success("Document uploaded successfully.");
                } else {
                    toast.error("Upload failed.");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setIsUploadingForPendingHistory(false));
        if (pendingFileInputRefs.current[index]) {
            pendingFileInputRefs.current[index].value = "";
        }
    };

    const handleDeletePendingAttachment = (fieldIndex, attIndex) => {
        const updated = [...pendingHistoryFields];
        const attList = [...(updated[fieldIndex].HistoryAttachments || [])];
        attList.splice(attIndex, 1);
        updated[fieldIndex] = { ...updated[fieldIndex], HistoryAttachments: attList, History_Value: attList.length > 0 ? updated[fieldIndex].History_Value : "" };
        setPendingHistoryFields(updated);
    };

    const updateHistoryModalField = (patch, index) => {
        const updated = [...historyModalFields];
        updated[index] = { ...updated[index], ...patch };
        setHistoryModalFields(updated);
    };

    const handleHistoryModalAttachFile = (index) => {
        const field = historyModalFields[index];
        const { urnFileType, selectedHistoryFile } = field;
        setIsUploadingForHistoryModal(true);
        if (!selectedHistoryFile) {
            toast.error("Please select a file to upload.");
            setIsUploadingForHistoryModal(false);
            return;
        }
        const { isValid, error } = validatePendingFile(selectedHistoryFile);
        if (!isValid) {
            toast.error(error);
            setIsUploadingForHistoryModal(false);
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedHistoryFile);
        B2BRegistrationService.UploadAttachment(formData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const updated = [...historyModalFields];
                    updated[index] = {
                        ...field,
                        urnFileType,
                        selectedHistoryFile: null,
                        History_Value: data.Data,
                        Urn_File_Path: data.Data,
                        HistoryAttachments: [
                            ...(field.HistoryAttachments || []),
                            { filePath: data.Data, fileType: urnFileType, fileTypeId: field.urnFileTypeId || null, isNew: true }
                        ]
                    };
                    setHistoryModalFields(updated);
                    toast.success("Document uploaded successfully.");
                } else {
                    toast.error("Upload failed.");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setIsUploadingForHistoryModal(false));
        if (historyFileInputRefs.current[index]) {
            historyFileInputRefs.current[index].value = "";
        }
    };

    const handleDeleteHistoryModalAttachment = (fieldIndex, attIndex) => {
        const updated = [...historyModalFields];
        const attList = [...(updated[fieldIndex].HistoryAttachments || [])];
        attList.splice(attIndex, 1);
        updated[fieldIndex] = { ...updated[fieldIndex], HistoryAttachments: attList, History_Value: attList.length > 0 ? updated[fieldIndex].History_Value : "" };
        setHistoryModalFields(updated);
    };

    const handleSaveHistoryModal = () => {
        const attributes = historyModalFields.map(f => ({
            History_Attribute_Id: f.History_Attribute_Id,
            Patient_Test_Id: f.Patient_Test_Id,
            Test_History_Id: f.Test_History_Id,
            Test_History_Attribute_Id: f.Test_History_Attribute_Id,
            History_Attribute: f.History_Attribute,
            History_Name: f.History_Name,
            Is_Mandatory: f.Is_Mandatory || false,
            History_Value: f.History_Value || "",
            Urn_File_Path: f.Urn_File_Path || "",
            Urn_File_Type_Id: f.Urn_File_Type_Id || "",
            Urn_File_Type: f.Urn_File_Type || "",
            Urn_Of: f.Urn_Of || "",
            Urn_Number: f.Urn_Number || "",
            History_Attribute_Category: f.History_Attribute_Category || "",
            PatientNumber: f.PatientNumber || "",
            VisitNumber: f.VisitNumber || "",
            OrgId: f.OrgId || 0,
            VID: f.VID || "",
            TestCode: f.TestCode || "",
            TestName: f.TestName || "",
            DocumentType: f.History_Attribute === "Attachement"
                ? (f.HistoryAttachments || []).some(a => a.fileType?.trim().toLowerCase() === "prescription")
                    ? "PRE"
                    : "TSD"
                : "",
            Is_Pending: f.History_Attribute === "Attachement"
                ? f.Is_UploadAllAttachments
                    ? !(f.Options || []).every(opt =>
                        (f.HistoryAttachments || []).some(a =>
                            a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase()
                        )
                    )
                    : (f.HistoryAttachments || []).length === 0
                : !f.History_Value,
            Attachments: (f.HistoryAttachments || []).length > 0
                ? JSON.stringify(f.HistoryAttachments.map(a => ({
                    fileTypeId: a.fileTypeId,
                    fileType: a.fileType,
                    filePath: a.filePath,
                    isNew: a.isNew || false
                })))
                : ""
        }));

        const payload = { HistoryAttributes: attributes };
        setSavingHistoryModal(true);
        TRFListRegistrationService.UpdateHistoryAttributes(payload)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    toast.success("History attributes updated successfully.");
                    setShowHistoryModal(false);
                    setSelectedTest(null);
                    GetB2BTRFRegistrationDetailByTRFId(b2bTRFRegistrationDetails.Reg_Trf_Id);
                    fetchB2BTRFRegistrationListData();
                } else {
                    toast.error(data.ResponseMessage || "Failed to update attributes.");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSavingHistoryModal(false));
    };

    const handleSavePendingAttributes = () => {

        const attributes = pendingHistoryFields.map(f => ({
            History_Attribute_Id: f.History_Attribute_Id,
            Patient_Test_Id: f.Patient_Test_Id,
            Test_History_Id: f.Test_History_Id,
            Test_History_Attribute_Id: f.Test_History_Attribute_Id,
            History_Attribute: f.History_Attribute,
            History_Name: f.History_Name,
            Is_Mandatory: f.Is_Mandatory || false,
            History_Value: f.History_Value || "",
            Urn_File_Path: f.Urn_File_Path || "",
            Urn_File_Type_Id: f.Urn_File_Type_Id || "",
            Urn_File_Type: f.Urn_File_Type || "",
            Urn_Of: f.Urn_Of || "",
            Urn_Number: f.Urn_Number || "",
            History_Attribute_Category: f.History_Attribute_Category || "",
            PatientNumber: f.PatientNumber || "",
            VisitNumber: f.VisitNumber || "",
            OrgId: f.OrgId || 0,
            VID: f.VID || "",
            TestCode: f.TestCode || "",
            TestName: f.TestName || "",
            DocumentType: f.History_Attribute === "Attachement"
                ? (f.HistoryAttachments || []).some(a => a.fileType?.trim().toLowerCase() === "prescription")
                    ? "PRE"
                    : "TSD"
                : "",
            Is_Pending: f.History_Attribute === "Attachement"
                ? f.Is_UploadAllAttachments
                    ? !(f.Options || []).every(opt =>
                        (f.HistoryAttachments || []).some(a =>
                            a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase()
                        )
                    )
                    : (f.HistoryAttachments || []).length === 0
                : !f.History_Value,
            Attachments: (f.HistoryAttachments || []).length > 0
                ? JSON.stringify(f.HistoryAttachments.map(a => ({
                    fileTypeId: a.fileTypeId,
                    fileType: a.fileType,
                    filePath: a.filePath,
                    isNew: a.isNew || false
                })))
                : ""
        }));

        const payload = {
            HistoryAttributes: attributes
        };

        setSavingPendingAttributes(true);

        TRFListRegistrationService.UpdateHistoryAttributes(payload)
            .then(({ data }) => {

                if (data.IsSuccess) {

                    toast.success("Pending attributes updated successfully.");

                    setShowPendingAttributesModal(false);
                    setSelectedPendingRegistration(null);

                    fetchB2BTRFRegistrationListData();

                } else {
                    toast.error(data.ResponseMessage || "Failed to update attributes.");
                }
            })
            .catch(() =>
                toast.error("Something went wrong.")
            )
            .finally(() =>
                setSavingPendingAttributes(false)
            );
    };

    const handleRegistration = () => {
        if (accountDetails.MHL_Status__c !== "Active") {
            Swal.fire({
                icon: "warning",
                title: "Action Not Allowed",
                text: "You don’t have permission to perform registration. Please contact MHL Admin for assistance.",
                confirmButtonText: "OK",
            });
            return;
        }

        navigate("/registration");
    };



    const [selectedTRFPDFArrayList, setSelectedTRFPDFArrayList] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
        const availableRecords = filteredB2BTRFRegistrationtList.filter(
            rec => rec.TRF_Status !== "Failed"
        );

        debugger;
        if (selectAll) {
            setSelectedTRFPDFArrayList([]);
        } else {
            const selected = availableRecords.map(rec => ({
                Reg_Trf_Id: rec.Reg_Trf_Id,
                VID: rec.Vid
            }));
            setSelectedTRFPDFArrayList(selected);
        }

        setSelectAll(!selectAll);
    };


    const handleCheckboxChange = (rec) => {
        const exists = selectedTRFPDFArrayList.some(
            r => r.Reg_Trf_Id === rec.Reg_Trf_Id
        );

        if (exists) {
            const updated = selectedTRFPDFArrayList.filter(
                r => r.Reg_Trf_Id !== rec.Reg_Trf_Id
            );
            setSelectedTRFPDFArrayList(updated);
            setSelectAll(false);
        } else {
            const updated = [
                ...selectedTRFPDFArrayList,
                { Reg_Trf_Id: rec.Reg_Trf_Id, VID: rec.Vid }
            ];
            setSelectedTRFPDFArrayList(updated);

            const availableRecords = filteredB2BTRFRegistrationtList.filter(
                // r => r.TRF_Status === "Processed"
                rec => rec.TRF_Status !== "Failed"
            );

            if (updated.length === filteredB2BTRFRegistrationtList.length) {
                setSelectAll(true);
            }
        }
    };

    const isChecked = (Reg_Trf_Id) =>
        selectedTRFPDFArrayList.some(r => r.Reg_Trf_Id === Reg_Trf_Id);


    const GetTRFRegistrationPDFList = () => {
        //debugger;

        if (!selectedTRFPDFArrayList || selectedTRFPDFArrayList.length === 0) {
            toast.error("Please select at least one TRF");
            return;
        }

        // const trfIds = selectedTRFPDFArrayList
        //     .map(x => x.Reg_Trf_Id)
        //     .join(",");

        // if (!trfIds) {
        //     toast.error("Invalid TRF selection");
        //     return;
        // }

        const requestBody = {
            selectedTRFList: selectedTRFPDFArrayList,
            orgName: orgId?.MHL_Organization_Name
        }

        setSearchLoading(true);
        setLoading(true);

        B2BRegistrationService.GetTRFRegistrationPDFListURL(requestBody)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    if (data.Data) {
                        window.open(data.Data, "_blank");
                        fetchB2BTRFRegistrationListData();
                    } else {
                        toast.error("PDF URL not found");
                    }
                } else {
                    toast.error(data.ResponseMessage || "Failed to generate PDF");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => { setSearchLoading(false); setLoading(false); });
    };


    // const [editingSampleIndex, setEditingSampleIndex] = useState(null);
    // const [selectedSampleStatus, setSelectedSampleStatus] = useState("");

    // NEW ---- pre-printed barcode support
    const [preprintedAllowedForTRF, setPreprintedAllowedForTRF] = useState(true);
    // keyed by row index -> entered pre-printed barcode
    const [samplePreBarcodes, setSamplePreBarcodes] = useState({});
    const [savingSampleStatus, setSavingSampleStatus] = useState(false);

    // Status / reason mapping (hard-coded defaults per spec)
    const SAMPLE_STATUS_CONFIG = {
        Collected: { statuscode: 5, reasoncode: 613, reason: "As Per Patient" },
    };
    const DEFAULT_STATUS_CONFIG = { statuscode: 0, reasoncode: 0, reason: "" };

    const isPreprintedEnabled =
        userDetails?.Is_Avail_For_PrePrintedBarcode === true && preprintedAllowedForTRF;

    const isPreprintedNotApplicable = (sample) => {
        const container = (sample?.Container_Name || "").trim().toUpperCase();
        const sampleName = (sample?.Sample_Name || "").trim().toUpperCase();
        return container === "NO CONTAINER" || sampleName === "NO SAMPLE";
    };

    // Validates one row's pre-printed barcode: format, length, duplicates, then API check.
    const validatePreprintedBarcodeForSample = async (sample, rowIndex) => {
        // Not applicable rows never need a barcode
        if (isPreprintedNotApplicable(sample)) return { ok: true, preBarcode: "" };

        const preBarcode = (samplePreBarcodes[rowIndex] || "").trim();

        if (!preBarcode) {
            toast.error(
                `Pre-printed barcode is required for Container: ${sample.Container_Name} (${sample.Sample_Name}).`
            );
            return { ok: false };
        }

        if (preBarcode.length !== CommonVariables.CONTAINERSIZEVALIDATION) {
            toast.error(
                `Invalid barcode length for Container: ${sample.Container_Name} (${sample.Sample_Name}), BarcodeId: ${preBarcode}`
            );
            return { ok: false };
        }

        // Duplicate check against other rows of the same container
        const allSamples = b2bTRFRegistrationDetails?.Patient_Test_Samples || [];
        const duplicate = allSamples.some((row, i) =>
            i !== rowIndex &&
            row.Container_Name === sample.Container_Name &&
            (samplePreBarcodes[i] || "").trim() === preBarcode
        );
        if (duplicate) {
            toast.error(
                `Duplicate barcode detected for Container: ${sample.Container_Name} (${sample.Sample_Name}), BarcodeId: ${preBarcode}`
            );
            return { ok: false };
        }

        // API validation
        try {
            const { data } = await B2BRegistrationService.ValidateContainerBarcodeId(
                sample.Container_Name,
                preBarcode
            );
            if (!data?.IsSuccess) {
                toast.error(
                    `Invalid container barcode: [SampleType: ${sample.Sample_Name}] [Container: ${sample.Container_Name}] [BarcodeId: ${preBarcode}] | ${data?.ResponseMessage || ""}`
                );
                return { ok: false };
            }
        } catch {
            toast.error("Something went wrong while validating container barcode.");
            return { ok: false };
        }

        return { ok: true, preBarcode };
    };

    // Fetches batch sheets. Optionally pre-filters the modal's search box by a VID
    // (used by the per-row batch sheet icon so only that row's batch sheet shows).
    const fetchBatchSheet = (vidFilter = "") => {
        setBatchSheetSearch(vidFilter);
        setBatchSheetPage(1);
        setBatchSheetLoading(true);
        setShowBatchSheetModal(true);
        const start = format(startDate, 'yyyy-MM-dd');
        const end = format(endDate, 'yyyy-MM-dd');
        B2BRegistrationService.GetBatchSheet(clientCode, orgId?.MHL_Org_Id__c, start, end)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setBatchSheetData(data.Data);
                } else {
                    setBatchSheetData([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setBatchSheetLoading(false));
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 m-0 p-0">
            <Toaster position="top-center" reverseOrder={false} />
            <div className="card w-100 shadow-lg border-0 m-0 p-0" style={{ minHeight: "125vh" }}>
                <div className="card-body m-0">

                    {/* Header section */}
                    <div className="registration-list-header-section mb-3 gap-3">

                        {/* Heading and subheading inline */}
                        <div className="d-flex align-items-center flex-wrap gap-2">
                            <div className="mb-1"><FaClipboardList size={20} /></div>
                            <h4 className="m-0">Registrations</h4>
                        </div>

                        {/* Add button */}
                        <div className="d-flex align-items-center gap-2">
                            <button className="btn custom-sumbitbtn d-flex align-items-center common-container-btn registration-btn" onClick={handleRegistration}>
                                <FaPlus className="me-2" />
                                Registration
                            </button>
                        </div>

                    </div>

                    {/* Body content */}
                    <div>

                        <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">

                            <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between mb-2">

                                <div className="d-flex flex-column flex-md-row gap-1 align-items-md-center">

                                    <select
                                        className="form-select patient-visit-form-select mb-2 mb-md-0 custom-select-dropdown"
                                        style={{ maxWidth: "200px" }}
                                        value={dateRangeOption}
                                        onChange={handleDateRangeChange}
                                    >
                                        <option value="Today">Today</option>
                                        <option value="Yesterday">Yesterday</option>
                                        <option value="Current Week">Current Week</option>
                                        <option value="Last 7 Days">Last 7 Days</option>
                                        <option value="MTD">MTD</option>
                                        <option value="Last 30 Days">Last 30 Days</option>
                                        <option value="Custom">Custom</option>
                                    </select>


                                    {(dateRangeOption === "Custom") && (
                                        <>
                                            <div className="position-relative mb-2 mb-md-0">
                                                <ReactDatePicker
                                                    selected={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                    className="form-control"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select Start Date"
                                                    ref={startDateRef}
                                                />
                                                <Calendar
                                                    size={20}
                                                    className="position-absolute "
                                                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                    onClick={() => startDateRef.current.setFocus()}
                                                />
                                            </div>

                                            <div className="position-relative mb-2 mb-md-0">
                                                <ReactDatePicker
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    className="form-control mobile-style"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select End Date"
                                                    ref={endDateRef}
                                                />
                                                <Calendar
                                                    size={20} className="position-absolute"
                                                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                    onClick={() => endDateRef.current.setFocus()}
                                                />
                                            </div>

                                        </>
                                    )}

                                    <div className="d-flex me-1 align-items-center">
                                        <button
                                            className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-btn"
                                            // style={{ height: "35px", padding: "0" }}
                                            onClick={fetchB2BTRFRegistrationListData}
                                            disabled={SearchLoading}
                                        >
                                            {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                                        </button>
                                    </div>

                                    <button
                                        className="btn custom-sumbitbtn ms-2"
                                        onClick={GetTRFRegistrationPDFList}
                                        disabled={SearchLoading}
                                    >
                                        {SearchLoading ? <><FaSpinner className="fa-spin" /> Please Wait ...</> : <b> {userDetails?.Is_Auto_VID_Generation ? "Generate Batchsheet" : "Download TRF List"} </b>}

                                    </button>

                                    {userDetails?.Is_Auto_VID_Generation && (
                                        <button
                                            className="btn custom-sumbitbtn ms-2"
                                            onClick={() => fetchBatchSheet()}
                                            disabled={SearchLoading}
                                        >
                                            <b>View Batchsheet</b>
                                        </button>
                                    )}

                                    {/* <div className="my-2">
                            {SearchLoading ?
                                <CommonVariables.LoadingMessage />
                                : null}
                        </div> */}
                                </div>

                            </div>

                            <div className="d-none flex-column flex-md-row gap-2 mb-2">

                                <div>

                                    <div className="d-flex flex-column flex-md-row gap-2" style={{ whiteSpace: "nowrap" }}>
                                        <div className="position-relative d-flex justify-content-between align-items-center ">
                                            <label className="mb-0 mr-2">Start Date:</label>
                                            <ReactDatePicker
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select Start Date"
                                                ref={startDateRef}
                                            />
                                            <Calendar
                                                size={20}
                                                className="position-absolute"
                                                style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                onClick={() => startDateRef.current.setFocus()}
                                            />
                                        </div>

                                        <div className="position-relative d-flex justify-content-between align-items-center ">
                                            <label className="mb-0 mr-2">End Date:</label>
                                            <ReactDatePicker
                                                selected={endDate}
                                                onChange={(date) => setEndDate(date)}
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select End Date"
                                                ref={endDateRef}
                                            />
                                            <Calendar
                                                size={20} className="position-absolute"
                                                style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                                onClick={() => endDateRef.current.setFocus()}
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <button
                                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-btn"
                                        style={{ height: "35px", padding: "0" }}
                                        onClick={fetchB2BTRFRegistrationListData}
                                        disabled={loading}
                                    >
                                        {/* <FaSearch /> */}
                                        {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                                    </button>
                                </div>
                                {/* <button
                        className="btn btn-danger d-flex align-items-center justify-content-center refresh-btn"
                        style={{ height: "35px", padding: "0" }}
                        onClick={() => window.location.reload()}
                    >
                        <FaSyncAlt />
                    </button> */}
                                <div>
                                    {SearchLoading ?
                                        <CommonVariables.LoadingMessage />
                                        : null}
                                </div>
                            </div>

                            <div className="search-box trf-registration-list-search-box" style={{ position: "relative", width: "320px" }}>
                                <div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Name, PID, VID, TRF ID"
                                        ref={selectedSearchPR}
                                        style={{
                                            paddingRight: "35px",
                                            borderRadius: "5px",
                                            border: "1px solid #ddd",
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                fetchUniversalFilterTRFListData();
                                            }
                                        }}
                                    />
                                    <button
                                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                                        style={{
                                            padding: '5px',
                                            position: "absolute",
                                            top: "0",
                                            right: "0px",
                                            height: "35px",
                                            width: "45px",
                                            // top: "49% !important",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            // transform: "translateY(-60%)"
                                        }}
                                        onClick={fetchUniversalFilterTRFListData}

                                        disabled={SearchLoading}
                                    >
                                        <FaSearch />
                                        {/* <span className="ms-2 d-md-none">Search</span> */}
                                    </button>
                                </div>
                            </div>

                            {/* <div className="search-box" style={{ position: "relative", }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        ref={selectedSearch}
                        style={{
                            paddingRight: "35px",
                            borderRadius: "5px",
                            border: "1px solid #ddd",
                        }}
                    />
                    <button
                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
                        style={{
                            padding: '5px',
                            position: "absolute",
                            right: "0px",
                            height: "35px",
                            width: "45px",
                            top: "50%",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                            transform: "translateY(-50%)"
                        }}
                        onClick={fetchUniversalTRFRegistrationData}
                        disabled={loading}
                    >
                        <FaSearch />
                    </button>

                </div> */}
                        </div>

                        {/* <div
                            className="d-flex justify-content-end align-items-center"
                            style={{ fontSize: "12px", color: "#666" }}
                        >
                            <FaExclamationTriangle
                                color="red"
                                size={12}
                                style={{ marginRight: "5px", marginTop: "-1px" }}
                            />
                            <span>
                                Pending documents/history required for report processing and doctor validation.
                            </span>
                        </div> */}

                        <div
                            className="d-flex justify-content-end align-items-center gap-3"
                            style={{ fontSize: "12px", color: "#666" }}
                        >
                            {/* Pending Documents */}
                            <div className="d-flex align-items-center">
                                <FaExclamationTriangle
                                    color="red"
                                    size={12}
                                    style={{ marginRight: "5px", marginTop: "-1px" }}
                                />
                                <span>Pending documents/history</span>
                            </div>

                            {/* Pending Sample */}
                            <div className="d-flex align-items-center">
                                <FaFlask
                                    color="#f39c12"
                                    size={12}
                                    style={{ marginRight: "5px", marginTop: "-1px" }}
                                />
                                <span>Pending sample</span>
                            </div>
                        </div>


                        {/* <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "650px" }}> */}
                        <div className="table-responsive">
                            <table className="table table-bordered custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "3%" }}>
                                            <input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={selectAll}
                                                title="Select All AVAILABLE"
                                            />
                                        </th>

                                        <th style={{ width: "22%" }}>TRF ID</th>
                                        <th style={{ width: "12%" }}>VID</th>
                                        <th>Patient Info</th>
                                        {/* <th>Patient Details</th> */}
                                        <th style={{ width: "12%" }}>Collection Date</th>

                                        {!userDetails?.Is_Auto_VID_Generation && (
                                            <th style={{ width: "10%" }}>Location</th>
                                        )}
                                        <th style={{ width: "8%" }}>Status</th>
                                        <th style={{ width: "12%" }}>Created Date</th>
                                        <th style={{ width: "8%" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="trf-detail-list-small-font">
                                    {currentfilteredB2BTRFRegistrationtList.length > 0 ? (
                                        currentfilteredB2BTRFRegistrationtList.map((item) => (
                                            <tr key={item.Registration_Id}>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    {/* {item.TRF_Status !== "Failed" && (
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleCheckboxChange(item)}
                                                            checked={isChecked(item.Reg_Trf_Id)}
                                                            title="Select to include in Report List"
                                                        />
                                                    )} */}
                                                    {item.TRF_Status !== "Failed" &&
                                                        !(
                                                            userDetails?.Is_Auto_VID_Generation === true &&
                                                            item.Is_BatchSheet_Created === true
                                                        ) && (
                                                            <input
                                                                type="checkbox"
                                                                onChange={() => handleCheckboxChange(item)}
                                                                checked={isChecked(item.Reg_Trf_Id)}
                                                                title="Select to include in Report List"
                                                            />
                                                        )}
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex gap-2 align-items-center justify-content-center">
                                                        {item.Reg_Trf_Id}
                                                        {item.Is_History_Attribute_Pending && item?.Vid && (
                                                            <span
                                                                title="Documents Pending"
                                                                style={{
                                                                    display: "inline-block",
                                                                    transition: "transform 0.2s",
                                                                    cursor: "pointer",
                                                                    marginBottom: "3px"
                                                                }}
                                                                onClick={() => GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id)}
                                                            >
                                                                <FaExclamationTriangle color="red" size={16} />
                                                            </span>
                                                        )}

                                                        {item.Is_Sample_Pending && (
                                                            <span
                                                                title="Sample Pending - Update Sample"
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    marginBottom: "3px"
                                                                }}
                                                                onClick={() => GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id)}
                                                            >
                                                                <FaFlask color="#f39c12" size={16} />
                                                            </span>
                                                        )}
                                                        {/* <br /> <strong>VID</strong>: {item.Vid || "-"}  */}
                                                    </div>
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {item.Vid ? (
                                                        <span
                                                            title="View VID Details"
                                                            style={{
                                                                color: '#007bff',
                                                                textDecoration: 'underline',
                                                                cursor: 'pointer',
                                                                fontSize: '13px',
                                                                transition: 'color 0.2s',
                                                            }}
                                                            onClick={() => GetPatientTestDetailTAT(item)}
                                                            onMouseEnter={e => (e.currentTarget.style.color = '#0056b3')}
                                                            onMouseLeave={e => (e.currentTarget.style.color = '#007bff')}
                                                        >
                                                            {item.Vid}
                                                        </span>
                                                    ) : (
                                                        <span style={{ color: 'gray', fontSize: '13px' }}>—</span>
                                                    )}
                                                </td>

                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <Popover
                                                        content={
                                                            <div style={{ textAlign: "left" }}>
                                                                <p><strong>Patient Name:</strong> {`${item.First_Name || ""} ${item.Middle_Name || ""} ${item.Last_Name || ""}`.trim()}</p>
                                                                <p><strong>DOB:</strong> {item.Dob ? new Date(item.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</p>
                                                                <p><strong>PID:</strong> {item.Pid || "-"}</p>
                                                                <p><strong>Mobile:</strong> {item.Mobile_Number || "Not Provided"}</p>
                                                                <p><strong>Gender:</strong> {item.Gender || "-"}</p>
                                                            </div>
                                                        }
                                                    >
                                                        <FaUser color="green" size={13} className="mb-1" /> &nbsp;
                                                    </Popover>

                                                    {/* Display only first 30 characters of the first name */}
                                                    <strong>
                                                        {(item.First_Name || "").length > 25
                                                            ? `${item.First_Name.substring(0, 25)}...`
                                                            : item.First_Name || ""}
                                                    </strong>
                                                    <br />

                                                    {item.Gender}
                                                    {item.Dob && (
                                                        <> | {format(parseISO(item.Dob), "dd-MMM-yyyy")} </>
                                                    )}
                                                </td>

                                                {/* <td>
                                        {`${item.First_Name || ""} ${item.Middle_Name || ""} ${item.Last_Name || ""}`.trim()}
                                    </td> */}
                                                <td className="text-center">
                                                    {new Date(item.Sample_Collection_Datetime).toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}
                                                    {/* <br />
                                                    <b>Created:</b>&nbsp; */}
                                                </td>

                                                {!userDetails?.Is_Auto_VID_Generation && (
                                                    <td>{item.Org_Location_Name}</td>
                                                )}
                                                <td>
                                                    {item.TRF_Status === "Failed" && (

                                                        <Popover
                                                            content={
                                                                <div style={{ textAlign: "left" }}>
                                                                    {/* <div><strong>Sr. No:</strong> {index + 1}</div> */}

                                                                    {!item?.TRF_Detail_Status?.Is_Trf_Generated && (
                                                                        <div>{item.TRF_Detail_Status?.Trf_Error_Message}</div>
                                                                    )}

                                                                    {!item?.TRF_Detail_Status?.Is_Registration && (
                                                                        <div>{item.TRF_Detail_Status?.Rni_Error_Message}</div>
                                                                    )}
                                                                </div>
                                                            }
                                                        >
                                                            {/* Icon triggers popover */}
                                                            <FaInfoCircle
                                                                color="green"
                                                                size={13}
                                                                className="mb-1"
                                                                style={{ cursor: "pointer" }}
                                                            />{" "}
                                                            &nbsp;
                                                        </Popover>
                                                    )}
                                                    {item.TRF_Status}
                                                </td>

                                                <td>
                                                    {new Date(item.Created_On).toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}

                                                </td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <div className="d-flex align-items-center gap-2 pl-2">
                                                        <div className="d-flex gap-2 align-items-center px-2">
                                                            {/* {item.Trf_Path ? (
                                                                <span
                                                                    disabled={loading}
                                                                    className="d-flex"
                                                                    title="View TRF PDF"
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        transition: 'transform 0.2s',
                                                                        cursor: 'pointer',
                                                                        fontSize: '12px'
                                                                    }}
                                                                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                >
                                                                    <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} />
                                                                </span>
                                                                // <i onClick={() => handleAttachmentDownload(item.Trf_Path)} role="button" style={{ color: "green", cursor: "pointer" }} className="fas fa-file-alt" >
                                                                // </i>
                                                            ) : (
                                                                "-"
                                                            )}
                                                             */}

                                                            {userDetails?.Is_Show_TRF_BaseURL ? (
                                                                item.TRFBaseURL ? (
                                                                    <span className="d-flex">
                                                                        <FaFileAlt color="green" size={16} onClick={() => window.open(item.TRFBaseURL, '_blank')} style={{ cursor: 'pointer' }} />
                                                                    </span>
                                                                ) : item.Trf_Path ? (
                                                                    <span
                                                                        disabled={loading}
                                                                        className="d-flex"
                                                                        title="View TRF PDF"
                                                                        style={{ display: 'inline-block', transition: 'transform 0.2s', cursor: 'pointer', fontSize: '12px' }}
                                                                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                    >
                                                                        <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} style={{ cursor: 'pointer' }} />
                                                                    </span>
                                                                ) : "-"
                                                            ) : item.Trf_Path ? (
                                                                <span
                                                                    disabled={loading}
                                                                    className="d-flex"
                                                                    title="View TRF PDF"
                                                                    style={{ display: 'inline-block', transition: 'transform 0.2s', cursor: 'pointer', fontSize: '12px' }}
                                                                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                >
                                                                    <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} style={{ cursor: 'pointer' }} />
                                                                </span>
                                                            ) : "-"}

                                                            <span
                                                                disabled={loading}
                                                                className="d-flex"
                                                                title="View TRF Details"
                                                                style={{
                                                                    display: 'inline-block',
                                                                    transition: 'transform 0.2s',
                                                                    cursor: 'pointer',
                                                                    fontSize: '12px'
                                                                }}
                                                                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                onClick={() => { GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id) }}

                                                            >
                                                                <Eye color="green" />
                                                            </span>

                                                            {item.TRF_Status === "Failed" && (
                                                                <span
                                                                    title="ReTry Registration"
                                                                    style={{
                                                                        display: "inline-block",
                                                                        transition: "transform 0.2s",
                                                                        cursor: "pointer",
                                                                        fontSize: "15px",
                                                                    }}
                                                                    onMouseEnter={(e) =>
                                                                        (e.currentTarget.style.transform = "scale(1.2)")
                                                                    }
                                                                    onMouseLeave={(e) =>
                                                                        (e.currentTarget.style.transform = "scale(1)")
                                                                    }
                                                                >
                                                                    <FaPaperPlane
                                                                        disabled={SearchLoading}
                                                                        className="d-flex"
                                                                        style={{ color: "green" }}
                                                                        onClick={() => RepushFailedRegistration(item.Reg_Trf_Id)}
                                                                    />
                                                                </span>
                                                            )}

                                                            {userDetails?.Is_Auto_VID_Generation && item.Is_BatchSheet_Created && item.Vid && (
                                                                <span
                                                                    title="View Batch Sheet"
                                                                    style={{
                                                                        display: "inline-block",
                                                                        transition: "transform 0.2s",
                                                                        cursor: "pointer",
                                                                        fontSize: "12px"
                                                                    }}
                                                                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                >
                                                                    <FaFileAlt
                                                                        color="#007bff"
                                                                        size={16}
                                                                        onClick={() => fetchBatchSheet(item.Vid)}
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                </span>
                                                            )}


                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={userDetails?.Is_Auto_VID_Generation ? 8 : 9} className="text-center">
                                                No Registrations Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>




                        </div>

                        {showPatientTestTATModal && (
                            <PatientTestDetailsModalComponent
                                visit={visit}
                                handlePatientTestTATClose={() => setshowPatientTestTATModal(false)}
                                patient={patient}
                                samples={samples}
                                reportURL={reportURL}
                                handleReportDownload={handleReportDownload}
                                reportWOSURL={reportWOSURL}
                                visitStatus={visitStatus}
                                tests={tests}
                                crmVisitDetails={crmVisitDetails}
                            />
                        )}

                        {showPreview && b2bTRFRegistrationDetails && (
                            <>
                                <div className="modal-backdrop" > </div>
                                <div className="modal fade show d-block success" tabIndex="-1"
                                // style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                                >
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header custom-card-heading text-white p-2">
                                                <h5 className="modal-title text-white px-2">Patient TRF Details ({b2bTRFRegistrationDetails.Reg_Trf_Id})</h5>
                                                <button type="button" className="btn-close btn-close-white mr-1" onClick={() => { setShowPreview(false); fetchB2BTRFRegistrationListData(); }}></button>
                                            </div>
                                            <div className="modal-body">

                                                {/* Patient Details */}
                                                <h6 className="mb-2"><strong>Patient Details</strong></h6>
                                                <div className="row">
                                                    <div className="col-md-6" style={{ borderRight: '1px solid #ccc' }}>
                                                        <p><strong>Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Salutation} {b2bTRFRegistrationDetails.Patient_Details?.First_Name} {b2bTRFRegistrationDetails.Patient_Details?.Middle_Name} {b2bTRFRegistrationDetails.Patient_Details?.Last_Name}</p>
                                                        <p><strong>Gender:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Gender}</p>
                                                        <p><strong>DOB:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Dob ? new Date(b2bTRFRegistrationDetails.Patient_Details.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</p>
                                                        <p>
                                                            <strong>Patient History:</strong>{" "}
                                                            {b2bTRFRegistrationDetails.Patient_History ? (() => {
                                                                const historyItems = b2bTRFRegistrationDetails.Patient_History
                                                                    .split(",")
                                                                    .map(x => x.trim())
                                                                    .filter(x => x);
                                                                if (historyItems.length === 0)
                                                                    return <span className="text-muted">No history</span>;
                                                                if (historyItems.length === 1)
                                                                    return <span>{historyItems[0]}</span>;
                                                                return (
                                                                    <Popover
                                                                        content={
                                                                            <ul className="list-unstyled m-0 p-1">
                                                                                {historyItems.map((item, i) => (
                                                                                    <li key={i}>{item}</li>
                                                                                ))}
                                                                            </ul>
                                                                        }
                                                                    >
                                                                        <span style={{ cursor: "pointer" }}>
                                                                            {historyItems[0]} +{historyItems.length - 1}
                                                                        </span>
                                                                    </Popover>
                                                                );
                                                            })() : (
                                                                <span className="text-muted">Not Provided</span>
                                                            )}
                                                        </p>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><strong>Mobile:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Mobile_Number || <span className="text-muted">Not Provided</span>}</p>
                                                        {/* <p><strong>Email:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Email || <span className="text-muted">Not Provided</span>}</p> */}
                                                        {/* <p><strong>Dr. Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p> */}
                                                        <p>
                                                            <strong>Remarks:</strong>{" "}
                                                            {b2bTRFRegistrationDetails.Remarks ? (
                                                                b2bTRFRegistrationDetails.Remarks.length > 40 ? (
                                                                    <Popover
                                                                        content={
                                                                            <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
                                                                                {b2bTRFRegistrationDetails.Remarks}
                                                                            </div>
                                                                        }
                                                                    >
                                                                        <span style={{ cursor: "pointer", textDecoration: "underline" }}>
                                                                            {b2bTRFRegistrationDetails.Remarks.slice(0, 40)}...
                                                                        </span>
                                                                    </Popover>
                                                                ) : (
                                                                    b2bTRFRegistrationDetails.Remarks
                                                                )
                                                            ) : (
                                                                <span className="text-muted">Not Provided</span>
                                                            )}
                                                        </p>
                                                        <p><strong>Ref. Dr Name:</strong>Dr. {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p>
                                                        <p><strong>Ref. ID:</strong> {b2bTRFRegistrationDetails.Patient_Details?.External_Order_Id || <span className="text-muted">Not Provided</span>}</p>
                                                    </div>
                                                </div>


                                                {/* Patient Attachments */}
                                                <div className="row mt-2">
                                                    <div className="col-md-12 d-flex align-items-center">
                                                        <strong>Patient Attachments:</strong>&nbsp;
                                                        {b2bTRFRegistrationDetails.Patient_Attachments &&
                                                            b2bTRFRegistrationDetails.Patient_Attachments.length > 0 ? (
                                                            <a
                                                                href="#"
                                                                onClick={(e) => { e.preventDefault(); setShowAttachments(true); }}
                                                                className="text-primary"
                                                                style={{ textDecoration: "underline", cursor: "pointer" }}
                                                            >
                                                                View Uploaded Attachments ({b2bTRFRegistrationDetails.Patient_Attachments.length})
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted">No patient attachments uploaded.</span>
                                                        )}
                                                    </div>

                                                </div>


                                                {/* Test Details */}
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <h6><strong>Lab Investigations</strong> ({b2bTRFRegistrationDetails.Patient_Tests?.length || 0})</h6>
                                                    <span><strong>Sample Date/Time: </strong>
                                                        {b2bTRFRegistrationDetails.Sample_Collection_Datetime &&
                                                            new Date(b2bTRFRegistrationDetails.Sample_Collection_Datetime).toLocaleString("en-GB", {
                                                                day: "2-digit", month: "short", year: "numeric",
                                                                hour: "2-digit", minute: "2-digit", hour12: true
                                                            }).replace(",", "").replace(/\s?(am|pm)/i, (m) => m.toUpperCase())}
                                                    </span>
                                                </div>

                                                <div style={{ maxHeight: "150px", overflowY: "auto" }} className="table-responsive-trf-summary mb-2">
                                                    <table className="table table-bordered custom-table mb-1">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th style={{ width: "35%" }}>Test Name (Code)</th>
                                                                {/* <th>Code</th> */}
                                                                <th>Test TAT</th>
                                                                <th style={{ width: "20%" }}>Test Remarks</th>
                                                                {/* <th>Type</th> */}
                                                                <th>Processing Location</th>
                                                                {/* {b2bTRFRegistrationDetails?.Vid &&(  */}
                                                                <th>Action</th>
                                                                {/* )} */}
                                                            </tr>
                                                        </thead>
                                                        <tbody className="trf-detail-list-small-font">
                                                            {b2bTRFRegistrationDetails.Patient_Tests?.length > 0 ? (
                                                                b2bTRFRegistrationDetails.Patient_Tests.map((test, idx) => (
                                                                    <tr key={idx}>
                                                                        <td className="text-left align-middle" style={{ width: '35%', whiteSpace: 'normal', wordBreak: 'break-word' }}>{test.Test_Name} (<b>{test.Test_Code}</b>)

                                                                            {test?.Is_History_Attribute_Pending && b2bTRFRegistrationDetails?.Vid && (
                                                                                <span
                                                                                    title="Documents Pending"
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        transition: "transform 0.2s",
                                                                                        cursor: "pointer",
                                                                                        marginLeft: "6px",
                                                                                        marginBottom: "3px"
                                                                                    }}
                                                                                >
                                                                                    <FaExclamationTriangle color="orange" size={16} />
                                                                                </span>
                                                                            )}

                                                                        </td>
                                                                        <td>{CommonVariables.formatUTCToIST(test.Test_Tat)}</td>
                                                                        <td>
                                                                            {test.Remarks
                                                                                ? test.Remarks.length > 20 ? (
                                                                                    <Popover
                                                                                        content={
                                                                                            <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
                                                                                                {test.Remarks}
                                                                                            </div>
                                                                                        }
                                                                                    >
                                                                                        <span style={{ cursor: "pointer" }}>
                                                                                            {test.Remarks.slice(0, 20)}...
                                                                                        </span>
                                                                                    </Popover>
                                                                                ) : (
                                                                                    test.Remarks
                                                                                )
                                                                                : (
                                                                                    "-"
                                                                                )}

                                                                        </td>
                                                                        <td> {test.Processing_Location && (
                                                                            <>
                                                                                {test.Processing_Location.includes(",") ? (
                                                                                    <Popover
                                                                                        content={
                                                                                            <ul
                                                                                                className="list-unstyled"
                                                                                                style={{ textAlign: "left", paddingLeft: "2px", margin: 0 }}
                                                                                            >
                                                                                                {test.Processing_Location.split(",").map((loc, index) => (
                                                                                                    <li key={index}>{loc.trim()}</li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        }
                                                                                    >
                                                                                        <span style={{ cursor: "pointer" }}>
                                                                                            {test.Processing_Location.split(",")[0]}{" "}
                                                                                            (+{test.Processing_Location.split(",").length - 1})
                                                                                        </span>
                                                                                    </Popover>
                                                                                ) : (
                                                                                    test.Processing_Location
                                                                                )}
                                                                            </>
                                                                        )}</td>
                                                                        {test.Is_Required_History &&

                                                                            // b2bTRFRegistrationDetails?.Vid &&
                                                                            (
                                                                                <td className="text-center">
                                                                                    <div
                                                                                        title="View Document"
                                                                                        style={{ cursor: "pointer" }}
                                                                                        onClick={() => {
                                                                                            setSelectedTest(test);
                                                                                            setHistoryModalFields(buildHistoryModalFields(test));
                                                                                            setShowHistoryModal(true);
                                                                                        }}
                                                                                    >
                                                                                        <FaEye color="green" size={19} />
                                                                                    </div>
                                                                                </td>
                                                                            )}
                                                                        {!test.Is_Required_History && (
                                                                            <td className="text-center text-muted">—</td>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr><td colSpan="4" className="text-center">No tests found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Patient Test Samples */}
                                                {/* <h6 className="mt-3 mb-2"><strong>Investigations Container & Samples</strong> ({b2bTRFRegistrationDetails.Patient_Test_Samples?.length || 0})</h6> */}

                                                <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
                                                    <h6 className="mb-0">
                                                        <strong>Investigations Container &amp; Samples</strong>{" "}
                                                        ({b2bTRFRegistrationDetails.Patient_Test_Samples?.length || 0})
                                                    </h6>

                                                    {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <label className="mb-0" style={{ fontSize: "13px" }}>
                                                                {preprintedAllowedForTRF ? "Disable" : "Enable"} Pre Printed Barcode:
                                                            </label>
                                                            <div
                                                                role="button"
                                                                className="border-0"
                                                                title="Toggle Pre-printed Barcode"
                                                                onClick={() => {
                                                                    if (preprintedAllowedForTRF) {
                                                                        setSamplePreBarcodes({}); // clear entered barcodes on disable
                                                                    }
                                                                    setPreprintedAllowedForTRF(prev => !prev);
                                                                }}
                                                            >
                                                                {preprintedAllowedForTRF
                                                                    ? <FaToggleOn size={18} color="green" />
                                                                    : <FaToggleOff size={18} color="red" />}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>


                                                <div style={{ maxHeight: "150px", overflowY: "auto" }} className="table-responsive-trf-summary mb-2">
                                                    <table className="table table-bordered custom-table">
                                                        <thead className="table-light">
                                                            {/* <tr>
                                                                <th>Container Name</th>
                                                                <th>Sample Name</th>
                                                                {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                                    <th>Barcode</th>
                                                                )}
                                                                <th>Sample Collected Status</th>
                                                                <th>Processing Location</th>
                                                            </tr> */}
                                                            <tr>
                                                                <th>Container Name</th>
                                                                <th>Sample Name</th>
                                                                {/* {userDetails?.Is_Avail_For_PrePrintedBarcode && (<th>Barcode</th>)} */}
                                                                {/* {isPreprintedEnabled && (<th>Pre-printed<br />Barcode</th>)} */}
                                                                {isPreprintedEnabled && (<th>Barcode</th>)}
                                                                <th>Sample Collected Status</th>
                                                                <th>Processing Location</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody className="trf-detail-list-small-font">
                                                            {b2bTRFRegistrationDetails.Patient_Test_Samples &&
                                                                b2bTRFRegistrationDetails.Patient_Test_Samples.length > 0 ? (
                                                                b2bTRFRegistrationDetails.Patient_Test_Samples.map((sample, i) => (
                                                                    <tr key={i}>
                                                                        <td>{sample.Container_Name}</td>
                                                                        <td>{sample.Sample_Name}</td>

                                                                        {/* {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                                            <td>{sample.Ref_BarcodeNo || sample.Barcode_Id || "-"}</td>
                                                                        )} */}

                                                                        {isPreprintedEnabled && (
                                                                            <td style={{ padding: "3px", textAlign: "center", minWidth: "170px" }}>
                                                                                {isPreprintedNotApplicable(sample) ? (
                                                                                    <span style={{ fontSize: "12px", color: "gray" }}>
                                                                                        Pre-printed barcode is not required
                                                                                    </span>
                                                                                ) : sample.SampleCollectedFromPartner ? (
                                                                                    <span style={{ fontSize: "12px", color: "gray" }}>
                                                                                        {sample.Pre_Barcode_Id || sample.Barcode_Id || sample.Ref_BarcodeNo || "—"}
                                                                                    </span>
                                                                                ) : (
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        placeholder="Enter Pre-printed Barcode"
                                                                                        maxLength={CommonVariables.CONTAINERSIZEVALIDATION}
                                                                                        value={samplePreBarcodes[i] || ""}
                                                                                        onChange={(e) => {
                                                                                            const val = e.target.value.replace(/[^0-9]/g, "");
                                                                                            setSamplePreBarcodes((prev) => ({ ...prev, [i]: val }));
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                        )}

                                                                        <td>
                                                                            {userDetails?.Is_Auto_VID_Generation ? (
                                                                                sample.SampleCollectedFromPartner ? (
                                                                                    <span className="badge bg-success">
                                                                                        Sample Collected
                                                                                    </span>
                                                                                ) : editingSampleIndex === i ? (
                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <select
                                                                                            className="form-select form-select-sm"
                                                                                            style={{ width: "150px" }}
                                                                                            value={selectedSampleStatus}
                                                                                            onChange={(e) => handleStatusChange(e.target.value)}
                                                                                        >
                                                                                            <option value="Collected">
                                                                                                Sample Collected
                                                                                            </option>

                                                                                            <option value={sample.SampleCollectedFromPartnerStatus}>
                                                                                                {sample.SampleCollectedFromPartnerStatus}
                                                                                            </option>
                                                                                        </select>

                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-success btn-sm"
                                                                                            title="Save & Sync"
                                                                                            disabled={savingSampleStatus}
                                                                                            onClick={() => handleSaveSampleStatus(sample, i)}
                                                                                        >
                                                                                            {savingSampleStatus ? (
                                                                                                <FaSpinner className="fa-spin" />
                                                                                            ) : (
                                                                                                <FaSave />
                                                                                            )}
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <span className="badge bg-warning text-dark">
                                                                                            {sample.SampleCollectedFromPartnerStatus}
                                                                                        </span>

                                                                                        <FaPen
                                                                                            color="green"
                                                                                            style={{ cursor: "pointer" }}
                                                                                            title="Edit"
                                                                                            onClick={() =>
                                                                                                handleEditSample(
                                                                                                    i,
                                                                                                    sample.SampleCollectedFromPartnerStatus
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            ) : (
                                                                                <span
                                                                                    className={`badge ${sample.SampleCollectedFromPartner ? "bg-success" : "bg-warning text-dark"
                                                                                        }`}
                                                                                >
                                                                                    {sample.SampleCollectedFromPartner ? "Sample Collected" : sample.SampleCollectedFromPartnerStatus
                                                                                    }

                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td>{sample.Processing_Location}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td
                                                                        colSpan={
                                                                            4 +
                                                                            (userDetails?.Is_Avail_For_PrePrintedBarcode ? 1 : 0) +
                                                                            (isPreprintedEnabled ? 1 : 0)
                                                                        }
                                                                        className="text-center"
                                                                    >
                                                                        No samples found
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>

                                            <div className="modal-footer p-2">
                                                {/* <button type="button" className="btn btn-danger" onClick={() => setShowPreview(false)}>Close</button> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}


                        {showAttachments && (
                            <div className="modal-backdrop w-100">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-l" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2 ml-1">
                                                <h5 className="modal-title">Patient Attachement</h5>
                                                <button type="button" className="btn-close mr-1" onClick={() => setShowAttachments(false)}></button>
                                            </div>
                                            <div className="modal-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                                {/* <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="table-responsive-trf-summary mb-1">
                                                    <table className="table table-bordered custom-table mb-1">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>#</th>
                                                                <th>File Type</th>
                                                                <th>URN Of</th>
                                                                <th>URN Number</th>
                                                                <th>File</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {b2bTRFRegistrationDetails.Patient_Attachments.map((att, i) => (
                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    <td>{att.Urn_File_Type}</td>
                                                                    <td>{att.Urn_Of}</td>
                                                                    <td>{att.Urn_Number}</td>
                                                                    <td>
                                                                        <a href={att.Urn_File_Path} target="_blank" rel="noopener noreferrer">View / Download</a>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div> */}

                                                <ul className="list-group small">
                                                    {b2bTRFRegistrationDetails.Patient_Attachments.map((att, idx) => (
                                                        <li className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center" key={idx}>
                                                            <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                {att.Urn_Of && <b>{att.Urn_Of.charAt(0)}</b>}
                                                                {att.Urn_Of ? " - " : ""}
                                                                {att.Urn_File_Type}
                                                                {att.Urn_Number ? ` (${att.Urn_Number})` : ""}
                                                            </span>
                                                            {/* <span className="px-2" style={{ whiteSpace: "nowrap" }}><b>{att.Urn_Of?.charAt(0)}</b> - {att.Urn_File_Type} ({att.Urn_Number})</span>        */}
                                                            <div className="d-flex align-items-center">

                                                                <div title="View Document" style={{ cursor: "pointer" }} onClick={() => handleAttachmentDownload(att.Urn_File_Path)} className="view-doc-btn-wrapper">
                                                                    <FaEye color="green" size={19} />
                                                                </div>

                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <TestHistoryModalComponent
                            show={showHistoryModal}
                            selectedTest={selectedTest}
                            fields={historyModalFields}
                            saving={savingHistoryModal}
                            uploading={isUploadingForHistoryModal}
                            fileInputRefs={historyFileInputRefs}
                            vid={b2bTRFRegistrationDetails?.Vid}
                            onClose={() => { setShowHistoryModal(false); setSelectedTest(null); }}
                            onFieldChange={updateHistoryModalField}
                            onAttachFile={handleHistoryModalAttachFile}
                            onDeleteAttachment={handleDeleteHistoryModalAttachment}
                            onSave={handleSaveHistoryModal}
                            onViewAttachment={handleAttachmentDownload}
                        />

                        {/* <PendingAttributesModalComponent
                            show={showPendingAttributesModal}
                            selectedPendingRegistration={selectedPendingRegistration}
                            fields={pendingHistoryFields}
                            loading={loadingPendingHistory}
                            saving={savingPendingAttributes}
                            uploading={isUploadingForPendingHistory}
                            fileInputRefs={pendingFileInputRefs}
                            onClose={() => { setShowPendingAttributesModal(false); setSelectedPendingRegistration(null); }}
                            onFieldChange={updatePendingField}
                            onAttachFile={handlePendingHistoryAttachFile}
                            onDeleteAttachment={handleDeletePendingAttachment}
                            onSave={handleSavePendingAttributes}
                            onViewAttachment={handleAttachmentDownload}
                        /> */}

                        {showBatchSheetModal && (
                            <>
                                <div className="modal-backdrop"></div>
                                <div className="modal fade show d-block" tabIndex="-1">
                                    <div className="modal-dialog modal-xl">
                                        <div className="modal-content">
                                            <div className="modal-header custom-card-heading text-white p-2">
                                                <h5 className="modal-title text-white px-2">Batch Sheets</h5>
                                                <button type="button" className="btn-close btn-close-white mr-1" onClick={() => setShowBatchSheetModal(false)}></button>
                                            </div>
                                            <div className="modal-body">
                                                {batchSheetLoading ? (
                                                    <div className="text-center py-4">
                                                        <FaSpinner className="fa-spin" size={24} />
                                                    </div>
                                                ) : (() => {
                                                    const BS_PAGE_SIZE = 8;
                                                    const q = batchSheetSearch.toLowerCase();
                                                    const filtered = batchSheetData.filter(item =>
                                                        !q ||
                                                        (item.ref_rni_batch_sheet_no || "").toLowerCase().includes(q) ||
                                                        (item.ref_vid || "").toLowerCase().includes(q) ||
                                                        (item.ref_trfid || "").toLowerCase().includes(q)
                                                    );
                                                    const totalPages = Math.max(1, Math.ceil(filtered.length / BS_PAGE_SIZE));
                                                    const safePage = Math.min(batchSheetPage, totalPages);
                                                    const pageRows = filtered.slice((safePage - 1) * BS_PAGE_SIZE, safePage * BS_PAGE_SIZE);
                                                    return (
                                                        <>
                                                            <div className="d-flex justify-content-end mb-2">
                                                                {/* Modal starts here */}
                                                                <div className="input-group" style={{ width: "280px" }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Search"
                                                                        value={batchSheetSearch}
                                                                        onChange={e => { setBatchSheetSearch(e.target.value); setBatchSheetPage(1); }}
                                                                    />
                                                                    <button
                                                                        className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
                                                                        style={{ width: "45px", borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }}
                                                                        tabIndex="-1"
                                                                    >
                                                                        <FaSearch />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered custom-table">
                                                                    <thead className="table-light">
                                                                        <tr>
                                                                            <th>Batch Sheet ID</th>
                                                                            {/* <th>Batch Sheet No</th> */}
                                                                            <th>VID(s)</th>
                                                                            <th>TRF ID(s)</th>
                                                                            <th>Created On</th>
                                                                            <th>PDF</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="trf-detail-list-small-font">
                                                                        {pageRows.length > 0 ? (
                                                                            pageRows.map((item) => (
                                                                                <tr key={item.batchsheetid}>
                                                                                    <td>{item.ref_rni_batch_sheet_id ? item.ref_rni_batch_sheet_id.split(",").map((v, idx) => (
                                                                                        <div key={idx}>{v.trim()}</div>
                                                                                    )) : "—"}</td>
                                                                                    {/* <td>{item.ref_rni_batch_sheet_no ? item.ref_rni_batch_sheet_no.split(",").map((v, idx) => (
                                                                                        <div key={idx}>{v.trim()}</div>
                                                                                    )) : "—"}</td> */}
                                                                                    <td>
                                                                                        {item.ref_vid ? item.ref_vid.split(",").map((v, idx) => (
                                                                                            <div key={idx}>{v.trim()}</div>
                                                                                        )) : "—"}
                                                                                    </td>
                                                                                    <td>
                                                                                        {item.ref_trfid ? item.ref_trfid.split(",").map((v, idx) => (
                                                                                            <div key={idx}>{v.trim()}</div>
                                                                                        )) : "—"}
                                                                                    </td>
                                                                                    <td>
                                                                                        {new Date(item.createdon).toLocaleString("en-GB", {
                                                                                            day: "2-digit", month: "short", year: "numeric",
                                                                                            hour: "2-digit", minute: "2-digit", hour12: true,
                                                                                        }).replace(",", "").replace(/\s?(am|pm)/i, m => m.toUpperCase())}
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        {item.pdf_url ? (
                                                                                            <span
                                                                                                title="View Batch Sheet PDF"
                                                                                                style={{ cursor: "pointer" }}
                                                                                                onClick={() => window.open(item.pdf_url, '_blank')}
                                                                                            >
                                                                                                <FaFileAlt color="green" size={16} />
                                                                                            </span>
                                                                                        ) : "—"}
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="5" className="text-center">No batch sheets found</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {filtered.length > BS_PAGE_SIZE && (
                                                                <CommonPagination
                                                                    pageList={filtered}
                                                                    currentPage={safePage}
                                                                    itemsPerPage={BS_PAGE_SIZE}
                                                                    setCurrentPage={setBatchSheetPage}
                                                                />
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                            <div className="modal-footer p-2">
                                                <button type="button" className="btn btn-danger" onClick={() => setShowBatchSheetModal(false)}>Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {filteredB2BTRFRegistrationtList.length > itemsPerPage ? (
                            <CommonPagination
                                pageList={filteredB2BTRFRegistrationtList}
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                setCurrentPage={setCurrentPage}
                            />
                        ) : null}
                    </div>
                </div>
            </div >
        </div >
    );
};

export default TRFRegistrationListComponent;
// import React, { useState, useRef, useEffect } from "react";
// import "../../Complaint.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import CommonContainer from "../Container/CommonContainer";
// import { useLocation, useNavigate } from "react-router-dom";
// import * as TRFListRegistrationService from "../../Services/B2BRegistration/TRFListRegistrationService";
// import toast, { Toaster } from "react-hot-toast";
// import * as moment from 'moment';
// import ReactDatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { FaFlask, FaInfoCircle, FaSearch, FaSpinner, FaEye, FaPaperPlane, FaSyncAlt, FaSave, FaCheckCircle, FaToggleOn, FaToggleOff, FaPen, FaTrash, FaTimesCircle, FaUser, FaFileAlt, FaClipboardList, FaPlus, FaExclamationTriangle } from "react-icons/fa";
// import { Calendar, Eye } from "lucide-react";
// import * as CommonVariables from '../../Common/CommonVariables'
// import Popover from '../../Common/Popper';
// import * as B2BRegistrationService from "../../Services/B2BRegistration/B2BRegistrationService";
// import * as PartnerService from "../../Services/Partner/PartnerService";
// import CommonPagination from "../../Common/CommonPagination";
// import { format, parseISO } from "date-fns";
// import PatientTestDetailsModalComponent from "../PatientVisit/PatientTestDetailsModalComponent";
// import { store } from "../../Store/store";
// import { useSelector } from "react-redux";
// import { trackPromise } from "react-promise-tracker";
// import axios from "axios";
// import "./TRFRegistrationListComponent.css"
// import TestHistoryModalComponent from "./TestHistoryModalComponent"
// import PendingAttributesModalComponent from "./PendingAttributesModalComponent"
// import Swal from "sweetalert2";


// const TRFRegistrationListComponent = () => {
//     const navigate = useNavigate();

//     const userInfo = store.getState();
//     const userDetails = userInfo?.userData;

//     const [filteredB2BTRFRegistrationtList, setFilteredB2BTRFRegistrationtList] = useState([]);
//     const [b2bTRFRegistrationDetails, setB2BTRFRegistrationDetails] = useState([]);
//     const [selectedTest, setSelectedTest] = useState([]);
//     const [showPreview, setShowPreview] = useState(false);
//     const [showAttachments, setShowAttachments] = useState(false);
//     const [showHistoryModal, setShowHistoryModal] = useState(false);
//     const [selectedPendingRegistration, setSelectedPendingRegistration] = useState(null);
//     const [showPendingAttributesModal, setShowPendingAttributesModal] = useState(false);
//     const [pendingHistoryFields, setPendingHistoryFields] = useState([]);
//     const [loadingPendingHistory, setLoadingPendingHistory] = useState(false);
//     const [savingPendingAttributes, setSavingPendingAttributes] = useState(false);
//     const [isUploadingForPendingHistory, setIsUploadingForPendingHistory] = useState(false);
//     const pendingFileInputRefs = useRef([]);
//     const [historyModalFields, setHistoryModalFields] = useState([]);
//     const [savingHistoryModal, setSavingHistoryModal] = useState(false);
//     const [isUploadingForHistoryModal, setIsUploadingForHistoryModal] = useState(false);
//     const historyFileInputRefs = useRef([]);
//     const [orgLocationList, setOrgLocationList] = useState([]);

//     const [startDate, setStartDate] = useState(new Date());
//     const [endDate, setEndDate] = useState(new Date());
//     const startDateRef = useRef(null);
//     const endDateRef = useRef(null);
//     const [loading, setLoading] = useState(false);
//     const [SearchLoading, setSearchLoading] = useState(false);
//     const [dateRangeOption, setDateRangeOption] = useState('Today');
//     const [showPatientTestDetails, setShowPatientTestDetails] = useState(false);
//     const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
//     const [patient, setPatient] = useState({});
//     const [visit, setVisit] = useState({});
//     const [samples, setSamples] = useState([]);
//     const [tests, setTests] = useState([]);
//     const [reportURL, setReportURL] = useState("");
//     const [reportWOSURL, setReportWOSURL] = useState("");
//     const [visitStatus, setVisitStatus] = useState("");
//     const [crmVisitDetails, setCRMVisitDetails] = useState([]);
//     const [showPatientTestTATModal, setshowPatientTestTATModal] = useState(false);
//     const [trflist, setTrflist] = useState([]);
//     const [showBatchSheetModal, setShowBatchSheetModal] = useState(false);
//     const [batchSheetData, setBatchSheetData] = useState([]);
//     const [batchSheetLoading, setBatchSheetLoading] = useState(false);
//     const [batchSheetSearch, setBatchSheetSearch] = useState("");
//     const [batchSheetPage, setBatchSheetPage] = useState(1);


//     const orgId = useSelector((state) => state.selectedOrganization);
//     const clientCode = useSelector((state) => state.Partner_Account_Details?.MHL_Client_Code__c);


//     const accountDetails = useSelector((state) => state.Partner_Account_Details);

//     const selectedSearchPR = useRef()

//     const location = useLocation();
//     const [initDone, setInitDone] = useState(false);


//     const GetPatientTestDetailTAT = (data) => {

//         setSearchLoading(true);
//         setCRMVisitDetails(data);
//         PartnerService.GetPatientTestsDetailsByVID(data.Vid, orgId.MHL_Org_Id__c)
//             .then(({ data }) => {
//                 //debugger;
//                 //console.log("PatientTest API response:", data);
//                 if (data.IsSuccess) {
//                     setshowPatientTestTATModal(true);
//                     const response = data.Data;

//                     setPatient(response.PatientDemographics || {});
//                     setVisit(response.PatientVisitDetails || {});
//                     setSamples(response.SampleInfoList || []);
//                     setTests(response.TestOrderDetails || []);
//                     setReportURL(response.ReportS3URL || "");
//                     setReportWOSURL(response.ReportWOSS3URL || "");
//                     setVisitStatus(response.VisitStatus || "");

//                     // setPatientReportList(data.Data);
//                 }
//                 else {
//                     // setPatientReportList([])
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setSearchLoading(false));
//         // setTestDetailsbyVID(data.MHL_Test_Details_List);
//     }

//     useEffect(() => {
//         if (orgId) {
//             fetchB2BTRFRegistrationListData();
//             setSelectedTRFPDFArrayList([]);
//             B2BRegistrationService.GetOrgLocationListByOrgId(orgId.MHL_Org_Id__c)
//                 .then(({ data }) => {
//                     if (data.IsSuccess) setOrgLocationList(data.Data || []);
//                 })
//                 .catch(() => { });
//         }
//     }, [orgId]);


//     useEffect(() => {
//         if (!initDone && location.state) {
//             const { startDate: passedStartDate, endDate: passedEndDate, dateRangeOption: passedOption } = location.state;

//             if (passedStartDate && endDate) {
//                 setDateRangeOption(passedOption || 'Custom');
//                 setStartDate(new Date(passedStartDate));
//                 setEndDate(new Date(passedEndDate));
//                 setInitDone(true); // Prevents re-running this logic
//             }
//         }
//     }, [location.state, initDone]);

//     useEffect(() => {
//         if (initDone && startDate && endDate) {
//             fetchB2BTRFRegistrationListData();
//         }
//     }, [initDone, startDate, endDate, dateRangeOption]);


//     useEffect(() => {
//         if (startDate && endDate) {
//             fetchB2BTRFRegistrationListData();
//         }
//     }, [dateRangeOption]);

//     const validateDateRange = (startDateValue, endDateValue) => {
//         if (!startDateValue || !endDateValue) {
//             toast.error("Please select a date range");
//             return false;
//         }
//         if (startDateValue > endDateValue) {
//             toast.error("Start date cannot be after end date");
//             return false;
//         }
//         if (endDateValue > new Date()) {
//             toast.error("End date cannot be in the future");
//             return false;
//         }
//         return true;
//     };

//     const handleReportDownload = async (reportURL) => {

//         const requestUrl = `${CommonVariables.API_DOMAIN}Account/Download?url=${encodeURIComponent(reportURL)}`;

//         try {
//             const response = await trackPromise(
//                 axios.get(requestUrl, CommonVariables.API_HEADER)
//             );

//             const fileUrl = response.data.Data; // assuming the API returns a direct URL to open
//             if (fileUrl) {
//                 window.open(fileUrl, '_blank');
//             } else {
//                 toast.error('File URL is empty.');
//             }

//         } catch (error) {
//             console.error('Download failed:', error);
//             toast.error('Download failed.');
//         }
//     };

//     const formatDate = (date, isEnd = false) => {
//         const d = new Date(date);
//         const year = d.getFullYear();
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const day = String(d.getDate()).padStart(2, "0");

//         if (isEnd) {
//             return `${year}-${month}-${day}T23:59:59`;
//         }
//         return `${year}-${month}-${day}T00:00:00`;
//     };

//     const fetchB2BTRFRegistrationListData = () => {
//         setFilteredB2BTRFRegistrationtList([]);
//         // if (!validateDateRange(startDate, endDate)) return;

//         if (dateRangeOption === "Custom") {
//             if (!startDate || !endDate) {
//                 toast.error("Please select both Start Date and End Date for Custom range");
//                 return;
//             }
//         }

//         setSearchLoading(true);
//         setLoading(true);
//         //debugger;

//         const payload = {
//             ClientCode: clientCode,
//             OrgId: parseInt(orgId?.MHL_Org_Id__c),
//             StartDate: formatDate(startDate),
//             EndDate: formatDate(endDate, true)
//         }

//         TRFListRegistrationService.GetB2BTRFRegistrationListData(payload)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     //console.log(data.Data);
//                     setFilteredB2BTRFRegistrationtList(data.Data);
//                 } else {
//                     setFilteredB2BTRFRegistrationtList([]);
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => {
//                 setLoading(false);
//                 setSearchLoading(false);
//             });
//     };

//     const fetchUniversalFilterTRFListData = () => {
//         if (!orgId) {
//             setFilteredB2BTRFRegistrationtList([])
//             return;
//         }

//         if (selectedSearchPR.current.value == null || selectedSearchPR.current.value == "") {
//             // window.location.reload();
//             toast.error("Please enter search data.")
//             return;
//         }
//         // setLoading(true);
//         setSearchLoading(true);
//         TRFListRegistrationService.GetUniversalB2BTRFRegistrationDataList(selectedSearchPR.current.value, clientCode)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     setFilteredB2BTRFRegistrationtList(data.Data);
//                 }
//                 else {
//                     setFilteredB2BTRFRegistrationtList([])
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setSearchLoading(false));
//     }

//     const [editingSampleIndex, setEditingSampleIndex] = useState(null);
//     const [selectedSampleStatus, setSelectedSampleStatus] = useState("");

//     const handleEditSample = (index, currentStatus) => {
//         setEditingSampleIndex(index);
//         setSelectedSampleStatus(currentStatus || "Collected");
//     };

//     const handleStatusChange = (value) => {
//         setSelectedSampleStatus(value);
//     };

//     const handleSaveSampleStatus = async (sample, rowIndex) => {
//         const vid = b2bTRFRegistrationDetails?.Vid;
//         if (!vid) {
//             toast.error("VID not available for this registration.");
//             return;
//         }

//         let preBarcode = "";

//         // Validate only when the partner is enabled AND the toggle is ON
//         if (isPreprintedEnabled) {
//             const result = await validatePreprintedBarcodeForSample(sample, rowIndex);
//             if (!result.ok) return;
//             preBarcode = result.preBarcode;
//         }

//         const statusConfig =
//             SAMPLE_STATUS_CONFIG[selectedSampleStatus] || DEFAULT_STATUS_CONFIG;

//         const payload = {
//             vid: vid,
//             sampleDetails: [
//                 {
//                     barcode: sample.Ref_BarcodeNo || "",
//                     preBarcode: preBarcode,
//                     sampleContainer: sample.Container_Name || "",
//                     sampleType: sample.Sample_Name || "",
//                     statuscode: statusConfig.statuscode,
//                     status: selectedSampleStatus,
//                     reasoncode: statusConfig.reasoncode,
//                     reason: statusConfig.reason,
//                 },
//             ],
//         };

//         setSavingSampleStatus(true);
//         try {
//             const { data } = await TRFListRegistrationService.UpdateRecollectSample(payload);
//             if (data?.IsSuccess) {
//                 toast.success("Sample status updated successfully.");
//                 setEditingSampleIndex(null);
//                 GetB2BTRFRegistrationDetailByTRFId(b2bTRFRegistrationDetails.Reg_Trf_Id);
//             } else {
//                 toast.error(data?.ResponseMessage || "Failed to update sample status.");
//             }
//         } catch {
//             toast.error("Something went wrong.");
//         } finally {
//             setSavingSampleStatus(false);
//         }
//     };


//     const GetB2BTRFRegistrationDetailByTRFId = (trfId) => {
//         //debugger;
//         // setLoading(true);
//         setSearchLoading(true);
//         TRFListRegistrationService.GetB2BTRFRegistrationDetailByTRFId(trfId)
//             .then(({ data }) => {
//                 //debugger;
//                 if (data.IsSuccess) {
//                     //console.log(data.Data);
//                     setB2BTRFRegistrationDetails(data.Data);
//                     setShowPreview(true);

//                     //NEW 
//                     setSamplePreBarcodes({});
//                     setEditingSampleIndex(null);
//                     setPreprintedAllowedForTRF(true);
//                 }
//                 else {
//                     setB2BTRFRegistrationDetails([])
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setSearchLoading(false));
//     }

//     const RepushFailedRegistration = (trfId) => {
//         //debugger;
//         // setLoading(true);
//         setSearchLoading(true);
//         TRFListRegistrationService.RepushFailedRegistration(trfId)
//             .then(({ data }) => {
//                 //debugger;
//                 if (data.IsSuccess) {
//                     fetchB2BTRFRegistrationListData();
//                     // setShowPreview(true);
//                     toast.success(data.ResponseMessage)
//                 }
//                 else {
//                     // setB2BTRFRegistrationDetails([])
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setSearchLoading(false));
//     }


//     // Pagination states
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(15); // Set number of items per page

//     // Pagination logic
//     const indexOfLastTRF = currentPage * itemsPerPage;
//     const indexOfFirstTRF = indexOfLastTRF - itemsPerPage;
//     const currentfilteredB2BTRFRegistrationtList = filteredB2BTRFRegistrationtList.slice(indexOfFirstTRF, indexOfLastTRF);

//     const handleAttachmentDownload = (url) => {
//         if (!url) {
//             toast.error("No file URL provided.");
//             return;
//         }
//         B2BRegistrationService.View_UploadedFile(url)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     //debugger;
//                     // window.open(data.Data, '_blank');
//                     const newWindow = window.open(data.Data, "_blank");
//                     if (newWindow) {
//                         newWindow.focus();
//                         newWindow.print();
//                     }
//                 } else {
//                     toast.error("Failed to download file.");
//                 }
//             })
//             .catch(() => toast.error("Something went wrong while downloading."));
//     };

//     const handleDateRangeChange = (e) => {
//         const selected = e.target.value;
//         setDateRangeOption(selected);

//         const today = new Date();
//         let start = null;
//         let end = null;

//         const startOfDay = (date) => {
//             const d = new Date(date);
//             d.setHours(0, 0, 0, 0);
//             return d;
//         };

//         const endOfDay = (date) => {
//             const d = new Date(date);
//             d.setHours(23, 59, 59, 999);
//             return d;
//         };

//         switch (selected) {
//             case 'Today':
//                 start = startOfDay(today);
//                 end = endOfDay(today);
//                 break;
//             case 'Yesterday':
//                 const yesterday = new Date(today);
//                 yesterday.setDate(today.getDate() - 1);
//                 start = startOfDay(yesterday);
//                 end = endOfDay(yesterday);
//                 break;
//             case 'Current Week':
//                 const dayOfWeek = today.getDay(); // 0 = Sunday
//                 start = startOfDay(new Date(today));
//                 start.setDate(today.getDate() - dayOfWeek);
//                 end = endOfDay(today);
//                 break;
//             case 'Last 7 Days':
//                 start = startOfDay(new Date(today));
//                 start.setDate(today.getDate() - 6); // includes today
//                 end = endOfDay(today);
//                 break;
//             case 'MTD':
//                 start = startOfDay(new Date(today.getFullYear(), today.getMonth(), 1));
//                 end = endOfDay(today);
//                 break;
//             case 'Last 30 Days':
//                 start = startOfDay(new Date(today));
//                 start.setDate(today.getDate() - 29); // last 30 days including today
//                 end = endOfDay(today);
//                 break;
//             case 'Custom':
//                 start = startDate;
//                 end = endDate;
//                 break;
//             default:
//                 break;
//         }

//         setStartDate(start);
//         setEndDate(end);
//     };


//     const calculateAge = (dob) => {
//         if (!dob) return "-";

//         const birthDate = new Date(dob);
//         const today = new Date();

//         let years = today.getFullYear() - birthDate.getFullYear();
//         let months = today.getMonth() - birthDate.getMonth();
//         let days = today.getDate() - birthDate.getDate();

//         // Adjust if negative
//         if (days < 0) {
//             months--;
//             const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
//             days += prevMonth;
//         }
//         if (months < 0) {
//             years--;
//             months += 12;
//         }

//         // Convert everything into total days for flexibility
//         const diffTime = today - birthDate;
//         const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
//         const totalMonths = years * 12 + months;

//         // Logic
//         if (years >= 2) {
//             return `${years} Year${years > 1 ? "s" : ""}`;
//         } else if (years >= 1) {
//             // show year with decimal (e.g. 1.6 Year)
//             const decimalYear = (totalMonths / 12).toFixed(1);
//             return `${decimalYear} Year`;
//         } else if (totalMonths >= 1) {
//             return `${totalMonths} Month${totalMonths > 1 ? "s" : ""}`;
//         } else if (totalDays >= 7) {
//             const weeks = Math.floor(totalDays / 7);
//             const remDays = totalDays % 7;
//             return `${weeks} Week${weeks > 1 ? "s" : ""}${remDays > 0 ? ` ${remDays} Day${remDays > 1 ? "s" : ""}` : ""}`;
//         } else {
//             return `${totalDays} Day${totalDays > 1 ? "s" : ""}`;
//         }
//     };


//     const buildHistoryModalFields = (test) => {
//         return (test.History_Attributes || []).map(att => {
//             const attachments = att.HistoryAttachments || [];

//             let selectedDateTime = "";
//             if (att.History_Attribute === "DateTime" && att.History_Value) {
//                 const d = new Date(att.History_Value);
//                 if (!isNaN(d.getTime())) {
//                     selectedDateTime = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
//                 }
//             }

//             let isPrefilled = false;
//             if (att.History_Attribute === "Attachement") {
//                 if (att.Is_UploadAllAttachments) {
//                     isPrefilled = (att.OptionsList || []).every(opt =>
//                         attachments.some(a => a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase())
//                     );
//                 } else {
//                     isPrefilled = attachments.length >= 1;
//                 }
//             } else {
//                 isPrefilled = !!att.History_Value;
//             }

//             return {
//                 Patient_Test_Id: test.Patient_Test_Id,
//                 History_Attribute_Id: att.History_Attribute_Id,
//                 Test_History_Attribute_Id: att.Test_History_Attribute_Id,
//                 Test_History_Id: att.Test_History_Id,
//                 History_Attribute: att.History_Attribute,
//                 History_Name: att.History_Name,
//                 Is_Mandatory: att.Is_Mandatory || false,
//                 Options: att.OptionsList || [],
//                 Is_UploadAllAttachments: att.Is_UploadAllAttachments || false,
//                 History_Value: att.History_Value || "",
//                 HistoryAttachments: attachments.map(a => ({ ...a, isNew: false })),
//                 Urn_File_Path: att.Urn_File_Path || "",
//                 Urn_File_Type_Id: "",
//                 Urn_File_Type: att.Urn_File_Type || "",
//                 Urn_Of: "",
//                 Urn_Number: att.Urn_Number || "",
//                 History_Attribute_Category: att.history_attribute_category || "",
//                 PatientNumber: b2bTRFRegistrationDetails?.Pid || "",
//                 VisitNumber: b2bTRFRegistrationDetails?.Vid || "",
//                 OrgId: b2bTRFRegistrationDetails?.Org_Id || 0,
//                 VID: b2bTRFRegistrationDetails?.Vid || "",
//                 TestCode: att.Test_Code || test.Test_Code || "",
//                 TestName: test.Test_Name || "",
//                 selectedDateTime,
//                 selectedOption: att.History_Attribute === "DropDown" ? (att.History_Value || "") : "",
//                 _testName: test.Test_Name,
//                 _testCode: test.Test_Code,
//                 _isPrefilled: isPrefilled,
//             };
//         });
//     };

//     const handlePendingAttributesClick = async (item) => {

//         setSelectedTest(null);
//         setSelectedPendingRegistration(item);
//         setLoadingPendingHistory(true);
//         setShowPendingAttributesModal(true);

//         try {

//             const { data } =
//                 await TRFListRegistrationService
//                     .GetHistoryAttributesByTRFId(item.Reg_Trf_Id);

//             if (!data.IsSuccess) {
//                 toast.error("Failed to load history attributes.");
//                 setPendingHistoryFields([]);
//                 return;
//             }

//             const flat = [];

//             (data.Data || []).forEach(test => {

//                 (test.History_Attributes || []).forEach(att => {

//                     const attachments = att.HistoryAttachments || [];

//                     let selectedDateTime = "";
//                     if (att.History_Attribute === "DateTime" && att.History_Value) {
//                         const d = new Date(att.History_Value);
//                         if (!isNaN(d.getTime())) {
//                             selectedDateTime =
//                                 `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")
//                                 }-${String(d.getDate()).padStart(2, "0")
//                                 }T${String(d.getHours()).padStart(2, "0")
//                                 }:${String(d.getMinutes()).padStart(2, "0")
//                                 }`;
//                         }
//                     }

//                     let isPrefilled = false;
//                     if (att.History_Attribute === "Attachement") {
//                         if (att.Is_UploadAllAttachments) {
//                             isPrefilled = (att.OptionsList || []).every(opt =>
//                                 attachments.some(a =>
//                                     a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase()
//                                 )
//                             );
//                         } else {
//                             isPrefilled = attachments.length >= 1;
//                         }
//                     } else {
//                         isPrefilled = !!att.History_Value;
//                     }

//                     flat.push({
//                         Patient_Test_Id: test.Patient_Test_Id,
//                         History_Attribute_Id: att.History_Attribute_Id,
//                         Test_History_Attribute_Id: att.Test_History_Attribute_Id,
//                         Test_History_Id: att.Test_History_Id,
//                         History_Attribute: att.History_Attribute,
//                         History_Name: att.History_Name,
//                         Is_Mandatory: att.Is_Mandatory || false,
//                         Options: att.OptionsList || [],
//                         Is_UploadAllAttachments: att.Is_UploadAllAttachments || false,
//                         History_Value: att.History_Value || "",
//                         HistoryAttachments: attachments.map(a => ({ ...a, isNew: false })),
//                         Urn_File_Path: att.Urn_File_Path || "",
//                         Urn_File_Type_Id: "",
//                         Urn_File_Type: att.Urn_File_Type || "",
//                         Urn_Of: "",
//                         Urn_Number: att.Urn_Number || "",
//                         History_Attribute_Category: att.history_attribute_category || "",
//                         PatientNumber: item?.Pid || "",
//                         VisitNumber: item?.Vid || "",
//                         OrgId: item?.Org_Id || 0,
//                         VID: item?.Vid || "",
//                         TestCode: att.Test_Code || test.Test_Code || "",
//                         TestName: test.Test_Name || "",
//                         selectedDateTime,
//                         selectedOption: att.History_Attribute === "DropDown"
//                             ? (att.History_Value || "")
//                             : "",
//                         _testName: test.Test_Name,
//                         _testCode: test.Test_Code,
//                         _isPrefilled: isPrefilled
//                     });

//                 });
//             });

//             setPendingHistoryFields(flat);

//         } catch (err) {

//             console.error(err);
//             toast.error("Something went wrong.");
//             setPendingHistoryFields([]);

//         } finally {
//             setLoadingPendingHistory(false);
//         }
//     };

//     const validatePendingFile = (file, maxSizeMB = 10) => {
//         if (!file) return { isValid: false, error: "No file selected." };
//         const allowedExtensions = [".jpg", ".jpeg", ".bitmap", ".pdf", ".doc", ".docx", ".tiff", ".msg", ".eml", ".zip"];
//         const fileName = file.name.toLowerCase();
//         const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
//         if (!isValidExtension) return { isValid: false, error: "Invalid file type. Allowed: JPG, JPEG, BITMAP, PDF, DOC, DOCX, TIFF, MSG, EML, ZIP" };
//         const maxSize = maxSizeMB * 1024 * 1024;
//         if (file.size > maxSize) return { isValid: false, error: `File size must be less than ${maxSizeMB} MB.` };
//         return { isValid: true };
//     };

//     const updatePendingField = (patch, index) => {
//         const updated = [...pendingHistoryFields];
//         updated[index] = { ...updated[index], ...patch };
//         setPendingHistoryFields(updated);
//     };

//     const handlePendingHistoryAttachFile = (index) => {
//         const field = pendingHistoryFields[index];
//         const { urnFileType, selectedHistoryFile } = field;
//         setIsUploadingForPendingHistory(true);
//         if (!selectedHistoryFile) {
//             toast.error("Please select a file to upload.");
//             setIsUploadingForPendingHistory(false);
//             return;
//         }
//         const { isValid, error } = validatePendingFile(selectedHistoryFile);
//         if (!isValid) {
//             toast.error(error);
//             setIsUploadingForPendingHistory(false);
//             return;
//         }
//         const formData = new FormData();
//         formData.append("file", selectedHistoryFile);
//         B2BRegistrationService.UploadAttachment(formData)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     const updated = [...pendingHistoryFields];
//                     updated[index] = {
//                         ...field,
//                         urnFileType,
//                         selectedHistoryFile: null,
//                         History_Value: data.Data,
//                         Urn_File_Path: data.Data,
//                         HistoryAttachments: [
//                             ...(field.HistoryAttachments || []),
//                             { filePath: data.Data, fileType: urnFileType, fileTypeId: field.urnFileTypeId || null, isNew: true }
//                         ]
//                     };
//                     setPendingHistoryFields(updated);
//                     toast.success("Document uploaded successfully.");
//                 } else {
//                     toast.error("Upload failed.");
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setIsUploadingForPendingHistory(false));
//         if (pendingFileInputRefs.current[index]) {
//             pendingFileInputRefs.current[index].value = "";
//         }
//     };

//     const handleDeletePendingAttachment = (fieldIndex, attIndex) => {
//         const updated = [...pendingHistoryFields];
//         const attList = [...(updated[fieldIndex].HistoryAttachments || [])];
//         attList.splice(attIndex, 1);
//         updated[fieldIndex] = { ...updated[fieldIndex], HistoryAttachments: attList, History_Value: attList.length > 0 ? updated[fieldIndex].History_Value : "" };
//         setPendingHistoryFields(updated);
//     };

//     const updateHistoryModalField = (patch, index) => {
//         const updated = [...historyModalFields];
//         updated[index] = { ...updated[index], ...patch };
//         setHistoryModalFields(updated);
//     };

//     const handleHistoryModalAttachFile = (index) => {
//         const field = historyModalFields[index];
//         const { urnFileType, selectedHistoryFile } = field;
//         setIsUploadingForHistoryModal(true);
//         if (!selectedHistoryFile) {
//             toast.error("Please select a file to upload.");
//             setIsUploadingForHistoryModal(false);
//             return;
//         }
//         const { isValid, error } = validatePendingFile(selectedHistoryFile);
//         if (!isValid) {
//             toast.error(error);
//             setIsUploadingForHistoryModal(false);
//             return;
//         }
//         const formData = new FormData();
//         formData.append("file", selectedHistoryFile);
//         B2BRegistrationService.UploadAttachment(formData)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     const updated = [...historyModalFields];
//                     updated[index] = {
//                         ...field,
//                         urnFileType,
//                         selectedHistoryFile: null,
//                         History_Value: data.Data,
//                         Urn_File_Path: data.Data,
//                         HistoryAttachments: [
//                             ...(field.HistoryAttachments || []),
//                             { filePath: data.Data, fileType: urnFileType, fileTypeId: field.urnFileTypeId || null, isNew: true }
//                         ]
//                     };
//                     setHistoryModalFields(updated);
//                     toast.success("Document uploaded successfully.");
//                 } else {
//                     toast.error("Upload failed.");
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setIsUploadingForHistoryModal(false));
//         if (historyFileInputRefs.current[index]) {
//             historyFileInputRefs.current[index].value = "";
//         }
//     };

//     const handleDeleteHistoryModalAttachment = (fieldIndex, attIndex) => {
//         const updated = [...historyModalFields];
//         const attList = [...(updated[fieldIndex].HistoryAttachments || [])];
//         attList.splice(attIndex, 1);
//         updated[fieldIndex] = { ...updated[fieldIndex], HistoryAttachments: attList, History_Value: attList.length > 0 ? updated[fieldIndex].History_Value : "" };
//         setHistoryModalFields(updated);
//     };

//     const handleSaveHistoryModal = () => {
//         const attributes = historyModalFields.map(f => ({
//             History_Attribute_Id: f.History_Attribute_Id,
//             Patient_Test_Id: f.Patient_Test_Id,
//             Test_History_Id: f.Test_History_Id,
//             Test_History_Attribute_Id: f.Test_History_Attribute_Id,
//             History_Attribute: f.History_Attribute,
//             History_Name: f.History_Name,
//             Is_Mandatory: f.Is_Mandatory || false,
//             History_Value: f.History_Value || "",
//             Urn_File_Path: f.Urn_File_Path || "",
//             Urn_File_Type_Id: f.Urn_File_Type_Id || "",
//             Urn_File_Type: f.Urn_File_Type || "",
//             Urn_Of: f.Urn_Of || "",
//             Urn_Number: f.Urn_Number || "",
//             History_Attribute_Category: f.History_Attribute_Category || "",
//             PatientNumber: f.PatientNumber || "",
//             VisitNumber: f.VisitNumber || "",
//             OrgId: f.OrgId || 0,
//             VID: f.VID || "",
//             TestCode: f.TestCode || "",
//             TestName: f.TestName || "",
//             DocumentType: f.History_Attribute === "Attachement"
//                 ? (f.HistoryAttachments || []).some(a => a.fileType?.trim().toLowerCase() === "prescription")
//                     ? "PRE"
//                     : "TSD"
//                 : "",
//             Is_Pending: f.History_Attribute === "Attachement"
//                 ? f.Is_UploadAllAttachments
//                     ? !(f.Options || []).every(opt =>
//                         (f.HistoryAttachments || []).some(a =>
//                             a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase()
//                         )
//                     )
//                     : (f.HistoryAttachments || []).length === 0
//                 : !f.History_Value,
//             Attachments: (f.HistoryAttachments || []).length > 0
//                 ? JSON.stringify(f.HistoryAttachments.map(a => ({
//                     fileTypeId: a.fileTypeId,
//                     fileType: a.fileType,
//                     filePath: a.filePath,
//                     isNew: a.isNew || false
//                 })))
//                 : ""
//         }));

//         const payload = { HistoryAttributes: attributes };
//         setSavingHistoryModal(true);
//         TRFListRegistrationService.UpdateHistoryAttributes(payload)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     toast.success("History attributes updated successfully.");
//                     setShowHistoryModal(false);
//                     setSelectedTest(null);
//                     GetB2BTRFRegistrationDetailByTRFId(b2bTRFRegistrationDetails.Reg_Trf_Id);
//                     fetchB2BTRFRegistrationListData();
//                 } else {
//                     toast.error(data.ResponseMessage || "Failed to update attributes.");
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setSavingHistoryModal(false));
//     };

//     const handleSavePendingAttributes = () => {

//         const attributes = pendingHistoryFields.map(f => ({
//             History_Attribute_Id: f.History_Attribute_Id,
//             Patient_Test_Id: f.Patient_Test_Id,
//             Test_History_Id: f.Test_History_Id,
//             Test_History_Attribute_Id: f.Test_History_Attribute_Id,
//             History_Attribute: f.History_Attribute,
//             History_Name: f.History_Name,
//             Is_Mandatory: f.Is_Mandatory || false,
//             History_Value: f.History_Value || "",
//             Urn_File_Path: f.Urn_File_Path || "",
//             Urn_File_Type_Id: f.Urn_File_Type_Id || "",
//             Urn_File_Type: f.Urn_File_Type || "",
//             Urn_Of: f.Urn_Of || "",
//             Urn_Number: f.Urn_Number || "",
//             History_Attribute_Category: f.History_Attribute_Category || "",
//             PatientNumber: f.PatientNumber || "",
//             VisitNumber: f.VisitNumber || "",
//             OrgId: f.OrgId || 0,
//             VID: f.VID || "",
//             TestCode: f.TestCode || "",
//             TestName: f.TestName || "",
//             DocumentType: f.History_Attribute === "Attachement"
//                 ? (f.HistoryAttachments || []).some(a => a.fileType?.trim().toLowerCase() === "prescription")
//                     ? "PRE"
//                     : "TSD"
//                 : "",
//             Is_Pending: f.History_Attribute === "Attachement"
//                 ? f.Is_UploadAllAttachments
//                     ? !(f.Options || []).every(opt =>
//                         (f.HistoryAttachments || []).some(a =>
//                             a.fileType?.trim().toLowerCase() === opt?.trim().toLowerCase()
//                         )
//                     )
//                     : (f.HistoryAttachments || []).length === 0
//                 : !f.History_Value,
//             Attachments: (f.HistoryAttachments || []).length > 0
//                 ? JSON.stringify(f.HistoryAttachments.map(a => ({
//                     fileTypeId: a.fileTypeId,
//                     fileType: a.fileType,
//                     filePath: a.filePath,
//                     isNew: a.isNew || false
//                 })))
//                 : ""
//         }));

//         const payload = {
//             HistoryAttributes: attributes
//         };

//         setSavingPendingAttributes(true);

//         TRFListRegistrationService.UpdateHistoryAttributes(payload)
//             .then(({ data }) => {

//                 if (data.IsSuccess) {

//                     toast.success("Pending attributes updated successfully.");

//                     setShowPendingAttributesModal(false);
//                     setSelectedPendingRegistration(null);

//                     fetchB2BTRFRegistrationListData();

//                 } else {
//                     toast.error(data.ResponseMessage || "Failed to update attributes.");
//                 }
//             })
//             .catch(() =>
//                 toast.error("Something went wrong.")
//             )
//             .finally(() =>
//                 setSavingPendingAttributes(false)
//             );
//     };

//     const handleRegistration = () => {
//         if (accountDetails.MHL_Status__c !== "Active") {
//             Swal.fire({
//                 icon: "warning",
//                 title: "Action Not Allowed",
//                 text: "You don’t have permission to perform registration. Please contact MHL Admin for assistance.",
//                 confirmButtonText: "OK",
//             });
//             return;
//         }

//         navigate("/registration");
//     };



//     const [selectedTRFPDFArrayList, setSelectedTRFPDFArrayList] = useState([]);
//     const [selectAll, setSelectAll] = useState(false);

//     const handleSelectAll = () => {
//         const availableRecords = filteredB2BTRFRegistrationtList.filter(
//             rec => rec.TRF_Status !== "Failed"
//         );

//         debugger;
//         if (selectAll) {
//             setSelectedTRFPDFArrayList([]);
//         } else {
//             const selected = availableRecords.map(rec => ({
//                 Reg_Trf_Id: rec.Reg_Trf_Id,
//                 VID: rec.Vid
//             }));
//             setSelectedTRFPDFArrayList(selected);
//         }

//         setSelectAll(!selectAll);
//     };


//     const handleCheckboxChange = (rec) => {
//         const exists = selectedTRFPDFArrayList.some(
//             r => r.Reg_Trf_Id === rec.Reg_Trf_Id
//         );

//         if (exists) {
//             const updated = selectedTRFPDFArrayList.filter(
//                 r => r.Reg_Trf_Id !== rec.Reg_Trf_Id
//             );
//             setSelectedTRFPDFArrayList(updated);
//             setSelectAll(false);
//         } else {
//             const updated = [
//                 ...selectedTRFPDFArrayList,
//                 { Reg_Trf_Id: rec.Reg_Trf_Id, VID: rec.Vid }
//             ];
//             setSelectedTRFPDFArrayList(updated);

//             const availableRecords = filteredB2BTRFRegistrationtList.filter(
//                 // r => r.TRF_Status === "Processed"
//                 rec => rec.TRF_Status !== "Failed"
//             );

//             if (updated.length === filteredB2BTRFRegistrationtList.length) {
//                 setSelectAll(true);
//             }
//         }
//     };

//     const isChecked = (Reg_Trf_Id) =>
//         selectedTRFPDFArrayList.some(r => r.Reg_Trf_Id === Reg_Trf_Id);


//     const GetTRFRegistrationPDFList = () => {
//         //debugger;

//         if (!selectedTRFPDFArrayList || selectedTRFPDFArrayList.length === 0) {
//             toast.error("Please select at least one TRF");
//             return;
//         }

//         // const trfIds = selectedTRFPDFArrayList
//         //     .map(x => x.Reg_Trf_Id)
//         //     .join(",");

//         // if (!trfIds) {
//         //     toast.error("Invalid TRF selection");
//         //     return;
//         // }

//         const requestBody = {
//             selectedTRFList: selectedTRFPDFArrayList,
//             orgName: orgId?.MHL_Organization_Name
//         }

//         setSearchLoading(true);
//         setLoading(true);

//         B2BRegistrationService.GetTRFRegistrationPDFListURL(requestBody)
//             .then(({ data }) => {
//                 //debugger;
//                 if (data.IsSuccess) {
//                     if (data.Data) {
//                         window.open(data.Data, "_blank");
//                         fetchB2BTRFRegistrationListData();
//                     } else {
//                         toast.error("PDF URL not found");
//                     }
//                 } else {
//                     toast.error(data.ResponseMessage || "Failed to generate PDF");
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => { setSearchLoading(false); setLoading(false); });
//     };


//     // const [editingSampleIndex, setEditingSampleIndex] = useState(null);
//     // const [selectedSampleStatus, setSelectedSampleStatus] = useState("");

//     // NEW ---- pre-printed barcode support
//     const [preprintedAllowedForTRF, setPreprintedAllowedForTRF] = useState(true);
//     // keyed by row index -> entered pre-printed barcode
//     const [samplePreBarcodes, setSamplePreBarcodes] = useState({});
//     const [savingSampleStatus, setSavingSampleStatus] = useState(false);

//     // Status / reason mapping (hard-coded defaults per spec)
//     const SAMPLE_STATUS_CONFIG = {
//         Collected: { statuscode: 5, reasoncode: 613, reason: "As Per Patient" },
//     };
//     const DEFAULT_STATUS_CONFIG = { statuscode: 0, reasoncode: 0, reason: "" };

//     const isPreprintedEnabled =
//         userDetails?.Is_Avail_For_PrePrintedBarcode === true && preprintedAllowedForTRF;

//     const isPreprintedNotApplicable = (sample) => {
//         const container = (sample?.Container_Name || "").trim().toUpperCase();
//         const sampleName = (sample?.Sample_Name || "").trim().toUpperCase();
//         return container === "NO CONTAINER" || sampleName === "NO SAMPLE";
//     };

//     // Validates one row's pre-printed barcode: format, length, duplicates, then API check.
//     const validatePreprintedBarcodeForSample = async (sample, rowIndex) => {
//         // Not applicable rows never need a barcode
//         if (isPreprintedNotApplicable(sample)) return { ok: true, preBarcode: "" };

//         const preBarcode = (samplePreBarcodes[rowIndex] || "").trim();

//         if (!preBarcode) {
//             toast.error(
//                 `Pre-printed barcode is required for Container: ${sample.Container_Name} (${sample.Sample_Name}).`
//             );
//             return { ok: false };
//         }

//         if (preBarcode.length !== CommonVariables.CONTAINERSIZEVALIDATION) {
//             toast.error(
//                 `Invalid barcode length for Container: ${sample.Container_Name} (${sample.Sample_Name}), BarcodeId: ${preBarcode}`
//             );
//             return { ok: false };
//         }

//         // Duplicate check against other rows of the same container
//         const allSamples = b2bTRFRegistrationDetails?.Patient_Test_Samples || [];
//         const duplicate = allSamples.some((row, i) =>
//             i !== rowIndex &&
//             row.Container_Name === sample.Container_Name &&
//             (samplePreBarcodes[i] || "").trim() === preBarcode
//         );
//         if (duplicate) {
//             toast.error(
//                 `Duplicate barcode detected for Container: ${sample.Container_Name} (${sample.Sample_Name}), BarcodeId: ${preBarcode}`
//             );
//             return { ok: false };
//         }

//         // API validation
//         try {
//             const { data } = await B2BRegistrationService.ValidateContainerBarcodeId(
//                 sample.Container_Name,
//                 preBarcode
//             );
//             if (!data?.IsSuccess) {
//                 toast.error(
//                     `Invalid container barcode: [SampleType: ${sample.Sample_Name}] [Container: ${sample.Container_Name}] [BarcodeId: ${preBarcode}] | ${data?.ResponseMessage || ""}`
//                 );
//                 return { ok: false };
//             }
//         } catch {
//             toast.error("Something went wrong while validating container barcode.");
//             return { ok: false };
//         }

//         return { ok: true, preBarcode };
//     };

//     const fetchBatchSheet = () => {
//         setBatchSheetSearch("");
//         setBatchSheetPage(1);
//         setBatchSheetLoading(true);
//         setShowBatchSheetModal(true);
//         const start = format(startDate, 'yyyy-MM-dd');
//         const end = format(endDate, 'yyyy-MM-dd');
//         B2BRegistrationService.GetBatchSheet(clientCode, orgId?.MHL_Org_Id__c, start, end)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     setBatchSheetData(data.Data);
//                 } else {
//                     setBatchSheetData([]);
//                 }
//             })
//             .catch(() => toast.error("Something went wrong."))
//             .finally(() => setBatchSheetLoading(false));
//     };

//     return (
//         <div className="d-flex justify-content-center align-items-center min-vh-100 m-0 p-0">
//             <Toaster position="top-center" reverseOrder={false} />
//             <div className="card w-100 shadow-lg border-0 m-0 p-0" style={{ minHeight: "125vh" }}>
//                 <div className="card-body m-0">

//                     {/* Header section */}
//                     <div className="registration-list-header-section mb-3 gap-3">

//                         {/* Heading and subheading inline */}
//                         <div className="d-flex align-items-center flex-wrap gap-2">
//                             <div className="mb-1"><FaClipboardList size={20} /></div>
//                             <h4 className="m-0">Registrations</h4>
//                         </div>

//                         {/* Add button */}
//                         <div className="d-flex align-items-center gap-2">
//                             <button className="btn custom-sumbitbtn d-flex align-items-center common-container-btn registration-btn" onClick={handleRegistration}>
//                                 <FaPlus className="me-2" />
//                                 Registration
//                             </button>
//                         </div>

//                     </div>

//                     {/* Body content */}
//                     <div>

//                         <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">

//                             <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between mb-2">

//                                 <div className="d-flex flex-column flex-md-row gap-1 align-items-md-center">

//                                     <select
//                                         className="form-select patient-visit-form-select mb-2 mb-md-0 custom-select-dropdown"
//                                         style={{ maxWidth: "200px" }}
//                                         value={dateRangeOption}
//                                         onChange={handleDateRangeChange}
//                                     >
//                                         <option value="Today">Today</option>
//                                         <option value="Yesterday">Yesterday</option>
//                                         <option value="Current Week">Current Week</option>
//                                         <option value="Last 7 Days">Last 7 Days</option>
//                                         <option value="MTD">MTD</option>
//                                         <option value="Last 30 Days">Last 30 Days</option>
//                                         <option value="Custom">Custom</option>
//                                     </select>


//                                     {(dateRangeOption === "Custom") && (
//                                         <>
//                                             <div className="position-relative mb-2 mb-md-0">
//                                                 <ReactDatePicker
//                                                     selected={startDate}
//                                                     onChange={(date) => setStartDate(date)}
//                                                     className="form-control"
//                                                     dateFormat="dd-MM-yyyy"
//                                                     placeholderText="Select Start Date"
//                                                     ref={startDateRef}
//                                                 />
//                                                 <Calendar
//                                                     size={20}
//                                                     className="position-absolute "
//                                                     style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                                                     onClick={() => startDateRef.current.setFocus()}
//                                                 />
//                                             </div>

//                                             <div className="position-relative mb-2 mb-md-0">
//                                                 <ReactDatePicker
//                                                     selected={endDate}
//                                                     onChange={(date) => setEndDate(date)}
//                                                     className="form-control mobile-style"
//                                                     dateFormat="dd-MM-yyyy"
//                                                     placeholderText="Select End Date"
//                                                     ref={endDateRef}
//                                                 />
//                                                 <Calendar
//                                                     size={20} className="position-absolute"
//                                                     style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                                                     onClick={() => endDateRef.current.setFocus()}
//                                                 />
//                                             </div>

//                                         </>
//                                     )}

//                                     <div className="d-flex me-1 align-items-center">
//                                         <button
//                                             className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-btn"
//                                             // style={{ height: "35px", padding: "0" }}
//                                             onClick={fetchB2BTRFRegistrationListData}
//                                             disabled={SearchLoading}
//                                         >
//                                             {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
//                                         </button>
//                                     </div>

//                                     <button
//                                         className="btn custom-sumbitbtn ms-2"
//                                         onClick={GetTRFRegistrationPDFList}
//                                         disabled={SearchLoading}
//                                     >
//                                         {SearchLoading ? <><FaSpinner className="fa-spin" /> Please Wait ...</> : <b> {userDetails?.Is_Auto_VID_Generation ? "Generate Batchsheet" : "Download TRF List"} </b>}

//                                     </button>

//                                     {userDetails?.Is_Auto_VID_Generation && (
//                                         <button
//                                             className="btn custom-sumbitbtn ms-2"
//                                             onClick={fetchBatchSheet}
//                                             disabled={SearchLoading}
//                                         >
//                                             <b>View Batchsheet</b>
//                                         </button>
//                                     )}

//                                     {/* <div className="my-2">
//                             {SearchLoading ?
//                                 <CommonVariables.LoadingMessage />
//                                 : null}
//                         </div> */}
//                                 </div>

//                             </div>

//                             <div className="d-none flex-column flex-md-row gap-2 mb-2">

//                                 <div>

//                                     <div className="d-flex flex-column flex-md-row gap-2" style={{ whiteSpace: "nowrap" }}>
//                                         <div className="position-relative d-flex justify-content-between align-items-center ">
//                                             <label className="mb-0 mr-2">Start Date:</label>
//                                             <ReactDatePicker
//                                                 selected={startDate}
//                                                 onChange={(date) => setStartDate(date)}
//                                                 className="form-control"
//                                                 dateFormat="dd-MM-yyyy"
//                                                 placeholderText="Select Start Date"
//                                                 ref={startDateRef}
//                                             />
//                                             <Calendar
//                                                 size={20}
//                                                 className="position-absolute"
//                                                 style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                                                 onClick={() => startDateRef.current.setFocus()}
//                                             />
//                                         </div>

//                                         <div className="position-relative d-flex justify-content-between align-items-center ">
//                                             <label className="mb-0 mr-2">End Date:</label>
//                                             <ReactDatePicker
//                                                 selected={endDate}
//                                                 onChange={(date) => setEndDate(date)}
//                                                 className="form-control"
//                                                 dateFormat="dd-MM-yyyy"
//                                                 placeholderText="Select End Date"
//                                                 ref={endDateRef}
//                                             />
//                                             <Calendar
//                                                 size={20} className="position-absolute"
//                                                 style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                                                 onClick={() => endDateRef.current.setFocus()}
//                                             />
//                                         </div>

//                                     </div>
//                                 </div>

//                                 <div>
//                                     <button
//                                         className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-btn"
//                                         style={{ height: "35px", padding: "0" }}
//                                         onClick={fetchB2BTRFRegistrationListData}
//                                         disabled={loading}
//                                     >
//                                         {/* <FaSearch /> */}
//                                         {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
//                                     </button>
//                                 </div>
//                                 {/* <button
//                         className="btn btn-danger d-flex align-items-center justify-content-center refresh-btn"
//                         style={{ height: "35px", padding: "0" }}
//                         onClick={() => window.location.reload()}
//                     >
//                         <FaSyncAlt />
//                     </button> */}
//                                 <div>
//                                     {SearchLoading ?
//                                         <CommonVariables.LoadingMessage />
//                                         : null}
//                                 </div>
//                             </div>

//                             <div className="search-box trf-registration-list-search-box" style={{ position: "relative", width: "320px" }}>
//                                 <div>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         placeholder="Search by Name, PID, VID, TRF ID"
//                                         ref={selectedSearchPR}
//                                         style={{
//                                             paddingRight: "35px",
//                                             borderRadius: "5px",
//                                             border: "1px solid #ddd",
//                                         }}
//                                         onKeyDown={(e) => {
//                                             if (e.key === "Enter") {
//                                                 fetchUniversalFilterTRFListData();
//                                             }
//                                         }}
//                                     />
//                                     <button
//                                         className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
//                                         style={{
//                                             padding: '5px',
//                                             position: "absolute",
//                                             top: "0",
//                                             right: "0px",
//                                             height: "35px",
//                                             width: "45px",
//                                             // top: "49% !important",
//                                             borderTopLeftRadius: "0",
//                                             borderBottomLeftRadius: "0",
//                                             // transform: "translateY(-60%)"
//                                         }}
//                                         onClick={fetchUniversalFilterTRFListData}

//                                         disabled={SearchLoading}
//                                     >
//                                         <FaSearch />
//                                         {/* <span className="ms-2 d-md-none">Search</span> */}
//                                     </button>
//                                 </div>
//                             </div>

//                             {/* <div className="search-box" style={{ position: "relative", }}>
//                     <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search"
//                         ref={selectedSearch}
//                         style={{
//                             paddingRight: "35px",
//                             borderRadius: "5px",
//                             border: "1px solid #ddd",
//                         }}
//                     />
//                     <button
//                         className="btn custom-sumbitbtn d-flex align-items-center justify-content-center search-box-btn"
//                         style={{
//                             padding: '5px',
//                             position: "absolute",
//                             right: "0px",
//                             height: "35px",
//                             width: "45px",
//                             top: "50%",
//                             borderTopLeftRadius: "0",
//                             borderBottomLeftRadius: "0",
//                             transform: "translateY(-50%)"
//                         }}
//                         onClick={fetchUniversalTRFRegistrationData}
//                         disabled={loading}
//                     >
//                         <FaSearch />
//                     </button>

//                 </div> */}
//                         </div>

//                         {/* <div
//                             className="d-flex justify-content-end align-items-center"
//                             style={{ fontSize: "12px", color: "#666" }}
//                         >
//                             <FaExclamationTriangle
//                                 color="red"
//                                 size={12}
//                                 style={{ marginRight: "5px", marginTop: "-1px" }}
//                             />
//                             <span>
//                                 Pending documents/history required for report processing and doctor validation.
//                             </span>
//                         </div> */}

//                         <div
//                             className="d-flex justify-content-end align-items-center gap-3"
//                             style={{ fontSize: "12px", color: "#666" }}
//                         >
//                             {/* Pending Documents */}
//                             <div className="d-flex align-items-center">
//                                 <FaExclamationTriangle
//                                     color="red"
//                                     size={12}
//                                     style={{ marginRight: "5px", marginTop: "-1px" }}
//                                 />
//                                 <span>Pending documents/history</span>
//                             </div>

//                             {/* Pending Sample */}
//                             <div className="d-flex align-items-center">
//                                 <FaFlask
//                                     color="#f39c12"
//                                     size={12}
//                                     style={{ marginRight: "5px", marginTop: "-1px" }}
//                                 />
//                                 <span>Pending sample</span>
//                             </div>
//                         </div>


//                         {/* <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "650px" }}> */}
//                         <div className="table-responsive">
//                             <table className="table table-bordered custom-table">
//                                 <thead>
//                                     <tr>
//                                         <th style={{ width: "3%" }}>
//                                             <input
//                                                 type="checkbox"
//                                                 onChange={handleSelectAll}
//                                                 checked={selectAll}
//                                                 title="Select All AVAILABLE"
//                                             />
//                                         </th>

//                                         <th style={{ width: "22%" }}>TRF ID</th>
//                                         <th style={{ width: "12%" }}>VID</th>
//                                         <th>Patient Info</th>
//                                         {/* <th>Patient Details</th> */}
//                                         <th style={{ width: "12%" }}>Collection Date</th>

//                                         <th style={{ width: "10%" }}>Location</th>
//                                         <th style={{ width: "8%" }}>Status</th>
//                                         <th style={{ width: "12%" }}>Created Date</th>
//                                         <th style={{ width: "8%" }}>Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody className="trf-detail-list-small-font">
//                                     {currentfilteredB2BTRFRegistrationtList.length > 0 ? (
//                                         currentfilteredB2BTRFRegistrationtList.map((item) => (
//                                             <tr key={item.Registration_Id}>
//                                                 <td style={{ textAlign: "center", verticalAlign: "middle" }}>
//                                                     {/* {item.TRF_Status !== "Failed" && (
//                                                         <input
//                                                             type="checkbox"
//                                                             onChange={() => handleCheckboxChange(item)}
//                                                             checked={isChecked(item.Reg_Trf_Id)}
//                                                             title="Select to include in Report List"
//                                                         />
//                                                     )} */}
//                                                     {item.TRF_Status !== "Failed" &&
//                                                         !(
//                                                             userDetails?.Is_Auto_VID_Generation === true &&
//                                                             item.Is_BatchSheet_Created === true
//                                                         ) && (
//                                                             <input
//                                                                 type="checkbox"
//                                                                 onChange={() => handleCheckboxChange(item)}
//                                                                 checked={isChecked(item.Reg_Trf_Id)}
//                                                                 title="Select to include in Report List"
//                                                             />
//                                                         )}
//                                                 </td>
//                                                 <td className="text-center">
//                                                     <div className="d-flex gap-2 align-items-center justify-content-center">
//                                                         {item.Reg_Trf_Id}
//                                                         {item.Is_History_Attribute_Pending && item?.Vid && (
//                                                             <span
//                                                                 title="Documents Pending"
//                                                                 style={{
//                                                                     display: "inline-block",
//                                                                     transition: "transform 0.2s",
//                                                                     cursor: "pointer",
//                                                                     marginBottom: "3px"
//                                                                 }}
//                                                                 onClick={() => GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id)}
//                                                             >
//                                                                 <FaExclamationTriangle color="red" size={16} />
//                                                             </span>
//                                                         )}

//                                                         {item.Is_Sample_Pending && (
//                                                             <span
//                                                                 title="Sample Pending - Update Sample"
//                                                                 style={{
//                                                                     display: "inline-flex",
//                                                                     alignItems: "center",
//                                                                     cursor: "pointer",
//                                                                     marginBottom: "3px"
//                                                                 }}
//                                                                 onClick={() => GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id)}
//                                                             >
//                                                                 <FaFlask color="#f39c12" size={16} />
//                                                             </span>
//                                                         )}
//                                                         {/* <br /> <strong>VID</strong>: {item.Vid || "-"}  */}
//                                                     </div>
//                                                 </td>
//                                                 <td style={{ textAlign: 'center' }}>
//                                                     {item.Vid ? (
//                                                         <span
//                                                             title="View VID Details"
//                                                             style={{
//                                                                 color: '#007bff',
//                                                                 textDecoration: 'underline',
//                                                                 cursor: 'pointer',
//                                                                 fontSize: '13px',
//                                                                 transition: 'color 0.2s',
//                                                             }}
//                                                             onClick={() => GetPatientTestDetailTAT(item)}
//                                                             onMouseEnter={e => (e.currentTarget.style.color = '#0056b3')}
//                                                             onMouseLeave={e => (e.currentTarget.style.color = '#007bff')}
//                                                         >
//                                                             {item.Vid}
//                                                         </span>
//                                                     ) : (
//                                                         <span style={{ color: 'gray', fontSize: '13px' }}>—</span>
//                                                     )}
//                                                 </td>

//                                                 <td style={{ textAlign: "center", verticalAlign: "middle" }}>
//                                                     <Popover
//                                                         content={
//                                                             <div style={{ textAlign: "left" }}>
//                                                                 <p><strong>Patient Name:</strong> {`${item.First_Name || ""} ${item.Middle_Name || ""} ${item.Last_Name || ""}`.trim()}</p>
//                                                                 <p><strong>DOB:</strong> {item.Dob ? new Date(item.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</p>
//                                                                 <p><strong>PID:</strong> {item.Pid || "-"}</p>
//                                                                 <p><strong>Mobile:</strong> {item.Mobile_Number || "Not Provided"}</p>
//                                                                 <p><strong>Gender:</strong> {item.Gender || "-"}</p>
//                                                             </div>
//                                                         }
//                                                     >
//                                                         <FaUser color="green" size={13} className="mb-1" /> &nbsp;
//                                                     </Popover>

//                                                     {/* Display only first 30 characters of the first name */}
//                                                     <strong>
//                                                         {(item.First_Name || "").length > 25
//                                                             ? `${item.First_Name.substring(0, 25)}...`
//                                                             : item.First_Name || ""}
//                                                     </strong>
//                                                     <br />

//                                                     {item.Gender}
//                                                     {item.Dob && (
//                                                         <> | {format(parseISO(item.Dob), "dd-MMM-yyyy")} </>
//                                                     )}
//                                                 </td>

//                                                 {/* <td>
//                                         {`${item.First_Name || ""} ${item.Middle_Name || ""} ${item.Last_Name || ""}`.trim()}
//                                     </td> */}
//                                                 <td className="text-center">
//                                                     {new Date(item.Sample_Collection_Datetime).toLocaleString("en-GB", {
//                                                         day: "2-digit",
//                                                         month: "short",
//                                                         year: "numeric",
//                                                         hour: "2-digit",
//                                                         minute: "2-digit",
//                                                         hour12: true,
//                                                     }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}
//                                                     {/* <br />
//                                                     <b>Created:</b>&nbsp; */}
//                                                 </td>

//                                                 <td>{item.Org_Location_Name}</td>
//                                                 <td>
//                                                     {item.TRF_Status === "Failed" && (

//                                                         <Popover
//                                                             content={
//                                                                 <div style={{ textAlign: "left" }}>
//                                                                     {/* <div><strong>Sr. No:</strong> {index + 1}</div> */}

//                                                                     {!item?.TRF_Detail_Status?.Is_Trf_Generated && (
//                                                                         <div>{item.TRF_Detail_Status?.Trf_Error_Message}</div>
//                                                                     )}

//                                                                     {!item?.TRF_Detail_Status?.Is_Registration && (
//                                                                         <div>{item.TRF_Detail_Status?.Rni_Error_Message}</div>
//                                                                     )}
//                                                                 </div>
//                                                             }
//                                                         >
//                                                             {/* Icon triggers popover */}
//                                                             <FaInfoCircle
//                                                                 color="green"
//                                                                 size={13}
//                                                                 className="mb-1"
//                                                                 style={{ cursor: "pointer" }}
//                                                             />{" "}
//                                                             &nbsp;
//                                                         </Popover>
//                                                     )}
//                                                     {item.TRF_Status}
//                                                 </td>

//                                                 <td>
//                                                     {new Date(item.Created_On).toLocaleString("en-GB", {
//                                                         day: "2-digit",
//                                                         month: "short",
//                                                         year: "numeric",
//                                                         hour: "2-digit",
//                                                         minute: "2-digit",
//                                                         hour12: true,
//                                                     }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}

//                                                 </td>
//                                                 <td style={{ textAlign: "center", verticalAlign: "middle" }}>
//                                                     <div className="d-flex align-items-center gap-2 pl-2">
//                                                         <div className="d-flex gap-2 align-items-center px-2">
//                                                             {/* {item.Trf_Path ? (
//                                                                 <span
//                                                                     disabled={loading}
//                                                                     className="d-flex"
//                                                                     title="View TRF PDF"
//                                                                     style={{
//                                                                         display: 'inline-block',
//                                                                         transition: 'transform 0.2s',
//                                                                         cursor: 'pointer',
//                                                                         fontSize: '12px'
//                                                                     }}
//                                                                     onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
//                                                                     onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
//                                                                 >
//                                                                     <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} />
//                                                                 </span>
//                                                                 // <i onClick={() => handleAttachmentDownload(item.Trf_Path)} role="button" style={{ color: "green", cursor: "pointer" }} className="fas fa-file-alt" >
//                                                                 // </i>
//                                                             ) : (
//                                                                 "-"
//                                                             )}
//                                                              */}

//                                                             {userDetails?.Is_Show_TRF_BaseURL ? (
//                                                                 item.TRFBaseURL ? (
//                                                                     <span className="d-flex">
//                                                                         <FaFileAlt color="green" size={16} onClick={() => window.open(item.TRFBaseURL, '_blank')} style={{ cursor: 'pointer' }} />
//                                                                     </span>
//                                                                 ) : item.Trf_Path ? (
//                                                                     <span
//                                                                         disabled={loading}
//                                                                         className="d-flex"
//                                                                         title="View TRF PDF"
//                                                                         style={{ display: 'inline-block', transition: 'transform 0.2s', cursor: 'pointer', fontSize: '12px' }}
//                                                                         onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
//                                                                         onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
//                                                                     >
//                                                                         <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} style={{ cursor: 'pointer' }} />
//                                                                     </span>
//                                                                 ) : "-"
//                                                             ) : item.Trf_Path ? (
//                                                                 <span
//                                                                     disabled={loading}
//                                                                     className="d-flex"
//                                                                     title="View TRF PDF"
//                                                                     style={{ display: 'inline-block', transition: 'transform 0.2s', cursor: 'pointer', fontSize: '12px' }}
//                                                                     onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
//                                                                     onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
//                                                                 >
//                                                                     <FaFileAlt color="green" size={16} onClick={() => handleAttachmentDownload(item.Trf_Path)} style={{ cursor: 'pointer' }} />
//                                                                 </span>
//                                                             ) : "-"}

//                                                             <span
//                                                                 disabled={loading}
//                                                                 className="d-flex"
//                                                                 title="View TRF Details"
//                                                                 style={{
//                                                                     display: 'inline-block',
//                                                                     transition: 'transform 0.2s',
//                                                                     cursor: 'pointer',
//                                                                     fontSize: '12px'
//                                                                 }}
//                                                                 onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
//                                                                 onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
//                                                                 onClick={() => { GetB2BTRFRegistrationDetailByTRFId(item.Reg_Trf_Id) }}

//                                                             >
//                                                                 <Eye color="green" />
//                                                             </span>

//                                                             {item.TRF_Status === "Failed" && (
//                                                                 <span
//                                                                     title="ReTry Registration"
//                                                                     style={{
//                                                                         display: "inline-block",
//                                                                         transition: "transform 0.2s",
//                                                                         cursor: "pointer",
//                                                                         fontSize: "15px",
//                                                                     }}
//                                                                     onMouseEnter={(e) =>
//                                                                         (e.currentTarget.style.transform = "scale(1.2)")
//                                                                     }
//                                                                     onMouseLeave={(e) =>
//                                                                         (e.currentTarget.style.transform = "scale(1)")
//                                                                     }
//                                                                 >
//                                                                     <FaPaperPlane
//                                                                         disabled={SearchLoading}
//                                                                         className="d-flex"
//                                                                         style={{ color: "green" }}
//                                                                         onClick={() => RepushFailedRegistration(item.Reg_Trf_Id)}
//                                                                     />
//                                                                 </span>
//                                                             )}


//                                                         </div>
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="9" className="text-center">
//                                                 No Registrations Found
//                                             </td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>




//                         </div>

//                         {showPatientTestTATModal && (
//                             <PatientTestDetailsModalComponent
//                                 visit={visit}
//                                 handlePatientTestTATClose={() => setshowPatientTestTATModal(false)}
//                                 patient={patient}
//                                 samples={samples}
//                                 reportURL={reportURL}
//                                 handleReportDownload={handleReportDownload}
//                                 reportWOSURL={reportWOSURL}
//                                 visitStatus={visitStatus}
//                                 tests={tests}
//                                 crmVisitDetails={crmVisitDetails}
//                             />
//                         )}

//                         {showPreview && b2bTRFRegistrationDetails && (
//                             <>
//                                 <div className="modal-backdrop" > </div>
//                                 <div className="modal fade show d-block success" tabIndex="-1"
//                                 // style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//                                 >
//                                     <div className="modal-dialog modal-lg">
//                                         <div className="modal-content">
//                                             <div className="modal-header custom-card-heading text-white p-2">
//                                                 <h5 className="modal-title text-white px-2">Patient TRF Details ({b2bTRFRegistrationDetails.Reg_Trf_Id})</h5>
//                                                 <button type="button" className="btn-close btn-close-white mr-1" onClick={() => { setShowPreview(false); fetchB2BTRFRegistrationListData(); }}></button>
//                                             </div>
//                                             <div className="modal-body">

//                                                 {/* Patient Details */}
//                                                 <h6 className="mb-2"><strong>Patient Details</strong></h6>
//                                                 <div className="row">
//                                                     <div className="col-md-6" style={{ borderRight: '1px solid #ccc' }}>
//                                                         <p><strong>Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Salutation} {b2bTRFRegistrationDetails.Patient_Details?.First_Name} {b2bTRFRegistrationDetails.Patient_Details?.Middle_Name} {b2bTRFRegistrationDetails.Patient_Details?.Last_Name}</p>
//                                                         <p><strong>Gender:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Gender}</p>
//                                                         <p><strong>DOB:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Dob ? new Date(b2bTRFRegistrationDetails.Patient_Details.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}</p>
//                                                         <p>
//                                                             <strong>Patient History:</strong>{" "}
//                                                             {b2bTRFRegistrationDetails.Patient_History ? (() => {
//                                                                 const historyItems = b2bTRFRegistrationDetails.Patient_History
//                                                                     .split(",")
//                                                                     .map(x => x.trim())
//                                                                     .filter(x => x);
//                                                                 if (historyItems.length === 0)
//                                                                     return <span className="text-muted">No history</span>;
//                                                                 if (historyItems.length === 1)
//                                                                     return <span>{historyItems[0]}</span>;
//                                                                 return (
//                                                                     <Popover
//                                                                         content={
//                                                                             <ul className="list-unstyled m-0 p-1">
//                                                                                 {historyItems.map((item, i) => (
//                                                                                     <li key={i}>{item}</li>
//                                                                                 ))}
//                                                                             </ul>
//                                                                         }
//                                                                     >
//                                                                         <span style={{ cursor: "pointer" }}>
//                                                                             {historyItems[0]} +{historyItems.length - 1}
//                                                                         </span>
//                                                                     </Popover>
//                                                                 );
//                                                             })() : (
//                                                                 <span className="text-muted">Not Provided</span>
//                                                             )}
//                                                         </p>

//                                                     </div>
//                                                     <div className="col-md-6">
//                                                         <p><strong>Mobile:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Mobile_Number || <span className="text-muted">Not Provided</span>}</p>
//                                                         {/* <p><strong>Email:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Email || <span className="text-muted">Not Provided</span>}</p> */}
//                                                         {/* <p><strong>Dr. Name:</strong> {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p> */}
//                                                         <p>
//                                                             <strong>Remarks:</strong>{" "}
//                                                             {b2bTRFRegistrationDetails.Remarks ? (
//                                                                 b2bTRFRegistrationDetails.Remarks.length > 40 ? (
//                                                                     <Popover
//                                                                         content={
//                                                                             <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
//                                                                                 {b2bTRFRegistrationDetails.Remarks}
//                                                                             </div>
//                                                                         }
//                                                                     >
//                                                                         <span style={{ cursor: "pointer", textDecoration: "underline" }}>
//                                                                             {b2bTRFRegistrationDetails.Remarks.slice(0, 40)}...
//                                                                         </span>
//                                                                     </Popover>
//                                                                 ) : (
//                                                                     b2bTRFRegistrationDetails.Remarks
//                                                                 )
//                                                             ) : (
//                                                                 <span className="text-muted">Not Provided</span>
//                                                             )}
//                                                         </p>
//                                                         <p><strong>Ref. Dr Name:</strong>Dr. {b2bTRFRegistrationDetails.Patient_Details?.Doctor_Name || <span className="text-muted">Not Provided</span>}</p>
//                                                         <p><strong>Ref. ID:</strong> {b2bTRFRegistrationDetails.Patient_Details?.External_Order_Id || <span className="text-muted">Not Provided</span>}</p>
//                                                     </div>
//                                                 </div>


//                                                 {/* Patient Attachments */}
//                                                 <div className="row mt-2">
//                                                     <div className="col-md-12 d-flex align-items-center">
//                                                         <strong>Patient Attachments:</strong>&nbsp;
//                                                         {b2bTRFRegistrationDetails.Patient_Attachments &&
//                                                             b2bTRFRegistrationDetails.Patient_Attachments.length > 0 ? (
//                                                             <a
//                                                                 href="#"
//                                                                 onClick={(e) => { e.preventDefault(); setShowAttachments(true); }}
//                                                                 className="text-primary"
//                                                                 style={{ textDecoration: "underline", cursor: "pointer" }}
//                                                             >
//                                                                 View Uploaded Attachments ({b2bTRFRegistrationDetails.Patient_Attachments.length})
//                                                             </a>
//                                                         ) : (
//                                                             <span className="text-muted">No patient attachments uploaded.</span>
//                                                         )}
//                                                     </div>

//                                                 </div>


//                                                 {/* Test Details */}
//                                                 <div className="d-flex justify-content-between align-items-center mt-3">
//                                                     <h6><strong>Lab Investigations</strong> ({b2bTRFRegistrationDetails.Patient_Tests?.length || 0})</h6>
//                                                     <span><strong>Sample Date/Time: </strong>
//                                                         {b2bTRFRegistrationDetails.Sample_Collection_Datetime &&
//                                                             new Date(b2bTRFRegistrationDetails.Sample_Collection_Datetime).toLocaleString("en-GB", {
//                                                                 day: "2-digit", month: "short", year: "numeric",
//                                                                 hour: "2-digit", minute: "2-digit", hour12: true
//                                                             }).replace(",", "").replace(/\s?(am|pm)/i, (m) => m.toUpperCase())}
//                                                     </span>
//                                                 </div>

//                                                 <div style={{ maxHeight: "150px", overflowY: "auto" }} className="table-responsive-trf-summary mb-2">
//                                                     <table className="table table-bordered custom-table mb-1">
//                                                         <thead className="table-light">
//                                                             <tr>
//                                                                 <th style={{ width: "35%" }}>Test Name (Code)</th>
//                                                                 {/* <th>Code</th> */}
//                                                                 <th>Test TAT</th>
//                                                                 <th style={{ width: "20%" }}>Test Remarks</th>
//                                                                 {/* <th>Type</th> */}
//                                                                 <th>Processing Location</th>
//                                                                 {/* {b2bTRFRegistrationDetails?.Vid &&(  */}
//                                                                 <th>Action</th>
//                                                                 {/* )} */}
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody className="trf-detail-list-small-font">
//                                                             {b2bTRFRegistrationDetails.Patient_Tests?.length > 0 ? (
//                                                                 b2bTRFRegistrationDetails.Patient_Tests.map((test, idx) => (
//                                                                     <tr key={idx}>
//                                                                         <td className="text-left align-middle" style={{ width: '35%', whiteSpace: 'normal', wordBreak: 'break-word' }}>{test.Test_Name} (<b>{test.Test_Code}</b>)

//                                                                             {test?.Is_History_Attribute_Pending && b2bTRFRegistrationDetails?.Vid && (
//                                                                                 <span
//                                                                                     title="Documents Pending"
//                                                                                     style={{
//                                                                                         display: "inline-block",
//                                                                                         transition: "transform 0.2s",
//                                                                                         cursor: "pointer",
//                                                                                         marginLeft: "6px",
//                                                                                         marginBottom: "3px"
//                                                                                     }}
//                                                                                 >
//                                                                                     <FaExclamationTriangle color="orange" size={16} />
//                                                                                 </span>
//                                                                             )}

//                                                                         </td>
//                                                                         <td>{CommonVariables.formatUTCToIST(test.Test_Tat)}</td>
//                                                                         <td>
//                                                                             {test.Remarks
//                                                                                 ? test.Remarks.length > 20 ? (
//                                                                                     <Popover
//                                                                                         content={
//                                                                                             <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
//                                                                                                 {test.Remarks}
//                                                                                             </div>
//                                                                                         }
//                                                                                     >
//                                                                                         <span style={{ cursor: "pointer" }}>
//                                                                                             {test.Remarks.slice(0, 20)}...
//                                                                                         </span>
//                                                                                     </Popover>
//                                                                                 ) : (
//                                                                                     test.Remarks
//                                                                                 )
//                                                                                 : (
//                                                                                     "-"
//                                                                                 )}

//                                                                         </td>
//                                                                         <td> {test.Processing_Location && (
//                                                                             <>
//                                                                                 {test.Processing_Location.includes(",") ? (
//                                                                                     <Popover
//                                                                                         content={
//                                                                                             <ul
//                                                                                                 className="list-unstyled"
//                                                                                                 style={{ textAlign: "left", paddingLeft: "2px", margin: 0 }}
//                                                                                             >
//                                                                                                 {test.Processing_Location.split(",").map((loc, index) => (
//                                                                                                     <li key={index}>{loc.trim()}</li>
//                                                                                                 ))}
//                                                                                             </ul>
//                                                                                         }
//                                                                                     >
//                                                                                         <span style={{ cursor: "pointer" }}>
//                                                                                             {test.Processing_Location.split(",")[0]}{" "}
//                                                                                             (+{test.Processing_Location.split(",").length - 1})
//                                                                                         </span>
//                                                                                     </Popover>
//                                                                                 ) : (
//                                                                                     test.Processing_Location
//                                                                                 )}
//                                                                             </>
//                                                                         )}</td>
//                                                                         {test.Is_Required_History &&

//                                                                             // b2bTRFRegistrationDetails?.Vid &&
//                                                                             (
//                                                                                 <td className="text-center">
//                                                                                     <div
//                                                                                         title="View Document"
//                                                                                         style={{ cursor: "pointer" }}
//                                                                                         onClick={() => {
//                                                                                             setSelectedTest(test);
//                                                                                             setHistoryModalFields(buildHistoryModalFields(test));
//                                                                                             setShowHistoryModal(true);
//                                                                                         }}
//                                                                                     >
//                                                                                         <FaEye color="green" size={19} />
//                                                                                     </div>
//                                                                                 </td>
//                                                                             )}
//                                                                         {!test.Is_Required_History && (
//                                                                             <td className="text-center text-muted">—</td>
//                                                                         )}
//                                                                     </tr>
//                                                                 ))
//                                                             ) : (
//                                                                 <tr><td colSpan="4" className="text-center">No tests found</td></tr>
//                                                             )}
//                                                         </tbody>
//                                                     </table>
//                                                 </div>

//                                                 {/* Patient Test Samples */}
//                                                 {/* <h6 className="mt-3 mb-2"><strong>Investigations Container & Samples</strong> ({b2bTRFRegistrationDetails.Patient_Test_Samples?.length || 0})</h6> */}

//                                                 <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
//                                                     <h6 className="mb-0">
//                                                         <strong>Investigations Container &amp; Samples</strong>{" "}
//                                                         ({b2bTRFRegistrationDetails.Patient_Test_Samples?.length || 0})
//                                                     </h6>

//                                                     {userDetails?.Is_Avail_For_PrePrintedBarcode && (
//                                                         <div className="d-flex align-items-center gap-2">
//                                                             <label className="mb-0" style={{ fontSize: "13px" }}>
//                                                                 {preprintedAllowedForTRF ? "Disable" : "Enable"} Pre Printed Barcode:
//                                                             </label>
//                                                             <div
//                                                                 role="button"
//                                                                 className="border-0"
//                                                                 title="Toggle Pre-printed Barcode"
//                                                                 onClick={() => {
//                                                                     if (preprintedAllowedForTRF) {
//                                                                         setSamplePreBarcodes({}); // clear entered barcodes on disable
//                                                                     }
//                                                                     setPreprintedAllowedForTRF(prev => !prev);
//                                                                 }}
//                                                             >
//                                                                 {preprintedAllowedForTRF
//                                                                     ? <FaToggleOn size={18} color="green" />
//                                                                     : <FaToggleOff size={18} color="red" />}
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                 </div>


//                                                 <div style={{ maxHeight: "150px", overflowY: "auto" }} className="table-responsive-trf-summary mb-2">
//                                                     <table className="table table-bordered custom-table">
//                                                         <thead className="table-light">
//                                                             {/* <tr>
//                                                                 <th>Container Name</th>
//                                                                 <th>Sample Name</th>
//                                                                 {userDetails?.Is_Avail_For_PrePrintedBarcode && (
//                                                                     <th>Barcode</th>
//                                                                 )}
//                                                                 <th>Sample Collected Status</th>
//                                                                 <th>Processing Location</th>
//                                                             </tr> */}
//                                                             <tr>
//                                                                 <th>Container Name</th>
//                                                                 <th>Sample Name</th>
//                                                                 {/* {userDetails?.Is_Avail_For_PrePrintedBarcode && (<th>Barcode</th>)} */}
//                                                                 {/* {isPreprintedEnabled && (<th>Pre-printed<br />Barcode</th>)} */}
//                                                                 {isPreprintedEnabled && (<th>Barcode</th>)}
//                                                                 <th>Sample Collected Status</th>
//                                                                 <th>Processing Location</th>
//                                                             </tr>

//                                                         </thead>
//                                                         <tbody className="trf-detail-list-small-font">
//                                                             {b2bTRFRegistrationDetails.Patient_Test_Samples &&
//                                                                 b2bTRFRegistrationDetails.Patient_Test_Samples.length > 0 ? (
//                                                                 b2bTRFRegistrationDetails.Patient_Test_Samples.map((sample, i) => (
//                                                                     <tr key={i}>
//                                                                         <td>{sample.Container_Name}</td>
//                                                                         <td>{sample.Sample_Name}</td>

//                                                                         {/* {userDetails?.Is_Avail_For_PrePrintedBarcode && (
//                                                                             <td>{sample.Ref_BarcodeNo || sample.Barcode_Id || "-"}</td>
//                                                                         )} */}

//                                                                         {isPreprintedEnabled && (
//                                                                             <td style={{ padding: "3px", textAlign: "center", minWidth: "170px" }}>
//                                                                                 {isPreprintedNotApplicable(sample) ? (
//                                                                                     <span style={{ fontSize: "12px", color: "gray" }}>
//                                                                                         Pre-printed barcode is not required
//                                                                                     </span>
//                                                                                 ) : sample.SampleCollectedFromPartner ? (
//                                                                                     <span style={{ fontSize: "12px", color: "gray" }}>
//                                                                                         {sample.Pre_Barcode_Id || sample.Barcode_Id || sample.Ref_BarcodeNo || "—"}
//                                                                                     </span>
//                                                                                 ) : (
//                                                                                     <input
//                                                                                         type="text"
//                                                                                         className="form-control form-control-sm"
//                                                                                         placeholder="Enter Pre-printed Barcode"
//                                                                                         maxLength={CommonVariables.CONTAINERSIZEVALIDATION}
//                                                                                         value={samplePreBarcodes[i] || ""}
//                                                                                         onChange={(e) => {
//                                                                                             const val = e.target.value.replace(/[^0-9]/g, "");
//                                                                                             setSamplePreBarcodes((prev) => ({ ...prev, [i]: val }));
//                                                                                         }}
//                                                                                     />
//                                                                                 )}
//                                                                             </td>
//                                                                         )}

//                                                                         <td>
//                                                                             {userDetails?.Is_Auto_VID_Generation ? (
//                                                                                 sample.SampleCollectedFromPartner ? (
//                                                                                     <span className="badge bg-success">
//                                                                                         Sample Collected
//                                                                                     </span>
//                                                                                 ) : editingSampleIndex === i ? (
//                                                                                     <div className="d-flex align-items-center gap-2">
//                                                                                         <select
//                                                                                             className="form-select form-select-sm"
//                                                                                             style={{ width: "150px" }}
//                                                                                             value={selectedSampleStatus}
//                                                                                             onChange={(e) => handleStatusChange(e.target.value)}
//                                                                                         >
//                                                                                             <option value="Collected">
//                                                                                                 Sample Collected
//                                                                                             </option>

//                                                                                             <option value={sample.SampleCollectedFromPartnerStatus}>
//                                                                                                 {sample.SampleCollectedFromPartnerStatus}
//                                                                                             </option>
//                                                                                         </select>

//                                                                                         <button
//                                                                                             type="button"
//                                                                                             className="btn btn-success btn-sm"
//                                                                                             title="Save & Sync"
//                                                                                             disabled={savingSampleStatus}
//                                                                                             onClick={() => handleSaveSampleStatus(sample, i)}
//                                                                                         >
//                                                                                             {savingSampleStatus ? (
//                                                                                                 <FaSpinner className="fa-spin" />
//                                                                                             ) : (
//                                                                                                 <FaSave />
//                                                                                             )}
//                                                                                         </button>
//                                                                                     </div>
//                                                                                 ) : (
//                                                                                     <div className="d-flex align-items-center gap-2">
//                                                                                         <span className="badge bg-warning text-dark">
//                                                                                             {sample.SampleCollectedFromPartnerStatus}
//                                                                                         </span>

//                                                                                         <FaPen
//                                                                                             color="green"
//                                                                                             style={{ cursor: "pointer" }}
//                                                                                             title="Edit"
//                                                                                             onClick={() =>
//                                                                                                 handleEditSample(
//                                                                                                     i,
//                                                                                                     sample.SampleCollectedFromPartnerStatus
//                                                                                                 )
//                                                                                             }
//                                                                                         />
//                                                                                     </div>
//                                                                                 )
//                                                                             ) : (
//                                                                                 <span
//                                                                                     className={`badge ${sample.SampleCollectedFromPartner ? "bg-success" : "bg-warning text-dark"
//                                                                                         }`}
//                                                                                 >
//                                                                                     {sample.SampleCollectedFromPartner ? "Sample Collected" : sample.SampleCollectedFromPartnerStatus
//                                                                                     }

//                                                                                 </span>
//                                                                             )}
//                                                                         </td>
//                                                                         <td>{sample.Processing_Location}</td>
//                                                                     </tr>
//                                                                 ))
//                                                             ) : (
//                                                                 <tr>
//                                                                     <td
//                                                                         colSpan={
//                                                                             4 +
//                                                                             (userDetails?.Is_Avail_For_PrePrintedBarcode ? 1 : 0) +
//                                                                             (isPreprintedEnabled ? 1 : 0)
//                                                                         }
//                                                                         className="text-center"
//                                                                     >
//                                                                         No samples found
//                                                                     </td>
//                                                                 </tr>
//                                                             )}
//                                                         </tbody>

//                                                     </table>
//                                                 </div>
//                                             </div>

//                                             <div className="modal-footer p-2">
//                                                 {/* <button type="button" className="btn btn-danger" onClick={() => setShowPreview(false)}>Close</button> */}

//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </>
//                         )}


//                         {showAttachments && (
//                             <div className="modal-backdrop w-100">
//                                 <div className="modal fade show d-block" tabIndex="-1" role="dialog">
//                                     <div className="modal-dialog modal-l" role="document">
//                                         <div className="modal-content">
//                                             <div className="modal-header p-2 ml-1">
//                                                 <h5 className="modal-title">Patient Attachement</h5>
//                                                 <button type="button" className="btn-close mr-1" onClick={() => setShowAttachments(false)}></button>
//                                             </div>
//                                             <div className="modal-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>
//                                                 {/* <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="table-responsive-trf-summary mb-1">
//                                                     <table className="table table-bordered custom-table mb-1">
//                                                         <thead className="table-light">
//                                                             <tr>
//                                                                 <th>#</th>
//                                                                 <th>File Type</th>
//                                                                 <th>URN Of</th>
//                                                                 <th>URN Number</th>
//                                                                 <th>File</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {b2bTRFRegistrationDetails.Patient_Attachments.map((att, i) => (
//                                                                 <tr key={i}>
//                                                                     <td>{i + 1}</td>
//                                                                     <td>{att.Urn_File_Type}</td>
//                                                                     <td>{att.Urn_Of}</td>
//                                                                     <td>{att.Urn_Number}</td>
//                                                                     <td>
//                                                                         <a href={att.Urn_File_Path} target="_blank" rel="noopener noreferrer">View / Download</a>
//                                                                     </td>
//                                                                 </tr>
//                                                             ))}
//                                                         </tbody>
//                                                     </table>
//                                                 </div> */}

//                                                 <ul className="list-group small">
//                                                     {b2bTRFRegistrationDetails.Patient_Attachments.map((att, idx) => (
//                                                         <li className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center" key={idx}>
//                                                             <span className="px-2" style={{ whiteSpace: "nowrap" }}>
//                                                                 {att.Urn_Of && <b>{att.Urn_Of.charAt(0)}</b>}
//                                                                 {att.Urn_Of ? " - " : ""}
//                                                                 {att.Urn_File_Type}
//                                                                 {att.Urn_Number ? ` (${att.Urn_Number})` : ""}
//                                                             </span>
//                                                             {/* <span className="px-2" style={{ whiteSpace: "nowrap" }}><b>{att.Urn_Of?.charAt(0)}</b> - {att.Urn_File_Type} ({att.Urn_Number})</span>        */}
//                                                             <div className="d-flex align-items-center">

//                                                                 <div title="View Document" style={{ cursor: "pointer" }} onClick={() => handleAttachmentDownload(att.Urn_File_Path)} className="view-doc-btn-wrapper">
//                                                                     <FaEye color="green" size={19} />
//                                                                 </div>

//                                                             </div>
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}

//                         <TestHistoryModalComponent
//                             show={showHistoryModal}
//                             selectedTest={selectedTest}
//                             fields={historyModalFields}
//                             saving={savingHistoryModal}
//                             uploading={isUploadingForHistoryModal}
//                             fileInputRefs={historyFileInputRefs}
//                             vid={b2bTRFRegistrationDetails?.Vid}
//                             onClose={() => { setShowHistoryModal(false); setSelectedTest(null); }}
//                             onFieldChange={updateHistoryModalField}
//                             onAttachFile={handleHistoryModalAttachFile}
//                             onDeleteAttachment={handleDeleteHistoryModalAttachment}
//                             onSave={handleSaveHistoryModal}
//                             onViewAttachment={handleAttachmentDownload}
//                         />

//                         {/* <PendingAttributesModalComponent
//                             show={showPendingAttributesModal}
//                             selectedPendingRegistration={selectedPendingRegistration}
//                             fields={pendingHistoryFields}
//                             loading={loadingPendingHistory}
//                             saving={savingPendingAttributes}
//                             uploading={isUploadingForPendingHistory}
//                             fileInputRefs={pendingFileInputRefs}
//                             onClose={() => { setShowPendingAttributesModal(false); setSelectedPendingRegistration(null); }}
//                             onFieldChange={updatePendingField}
//                             onAttachFile={handlePendingHistoryAttachFile}
//                             onDeleteAttachment={handleDeletePendingAttachment}
//                             onSave={handleSavePendingAttributes}
//                             onViewAttachment={handleAttachmentDownload}
//                         /> */}

//                         {showBatchSheetModal && (
//                             <>
//                                 <div className="modal-backdrop"></div>
//                                 <div className="modal fade show d-block" tabIndex="-1">
//                                     <div className="modal-dialog modal-xl">
//                                         <div className="modal-content">
//                                             <div className="modal-header custom-card-heading text-white p-2">
//                                                 <h5 className="modal-title text-white px-2">Batch Sheets</h5>
//                                                 <button type="button" className="btn-close btn-close-white mr-1" onClick={() => setShowBatchSheetModal(false)}></button>
//                                             </div>
//                                             <div className="modal-body">
//                                                 {batchSheetLoading ? (
//                                                     <div className="text-center py-4">
//                                                         <FaSpinner className="fa-spin" size={24} />
//                                                     </div>
//                                                 ) : (() => {
//                                                     const BS_PAGE_SIZE = 8;
//                                                     const q = batchSheetSearch.toLowerCase();
//                                                     const filtered = batchSheetData.filter(item =>
//                                                         !q ||
//                                                         (item.ref_rni_batch_sheet_no || "").toLowerCase().includes(q) ||
//                                                         (item.ref_vid || "").toLowerCase().includes(q) ||
//                                                         (item.ref_trfid || "").toLowerCase().includes(q)
//                                                     );
//                                                     const totalPages = Math.max(1, Math.ceil(filtered.length / BS_PAGE_SIZE));
//                                                     const safePage = Math.min(batchSheetPage, totalPages);
//                                                     const pageRows = filtered.slice((safePage - 1) * BS_PAGE_SIZE, safePage * BS_PAGE_SIZE);
//                                                     return (
//                                                         <>
//                                                             <div className="d-flex justify-content-end mb-2">
//                                                                 {/* Modal starts here */}
//                                                                 <div className="input-group" style={{ width: "280px" }}>
//                                                                     <input
//                                                                         type="text"
//                                                                         className="form-control"
//                                                                         placeholder="Search"
//                                                                         value={batchSheetSearch}
//                                                                         onChange={e => { setBatchSheetSearch(e.target.value); setBatchSheetPage(1); }}
//                                                                     />
//                                                                     <button
//                                                                         className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
//                                                                         style={{ width: "45px", borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }}
//                                                                         tabIndex="-1"
//                                                                     >
//                                                                         <FaSearch />
//                                                                     </button>
//                                                                 </div>
//                                                             </div>
//                                                             <div className="table-responsive">
//                                                                 <table className="table table-bordered custom-table">
//                                                                     <thead className="table-light">
//                                                                         <tr>
//                                                                             <th>Batch Sheet ID</th>
//                                                                             {/* <th>Batch Sheet No</th> */}
//                                                                             <th>VID(s)</th>
//                                                                             <th>TRF ID(s)</th>
//                                                                             <th>Created On</th>
//                                                                             <th>PDF</th>
//                                                                         </tr>
//                                                                     </thead>
//                                                                     <tbody className="trf-detail-list-small-font">
//                                                                         {pageRows.length > 0 ? (
//                                                                             pageRows.map((item) => (
//                                                                                 <tr key={item.batchsheetid}>
//                                                                                     <td>{item.ref_rni_batch_sheet_id ? item.ref_rni_batch_sheet_id.split(",").map((v, idx) => (
//                                                                                         <div key={idx}>{v.trim()}</div>
//                                                                                     )) : "—"}</td>
//                                                                                     {/* <td>{item.ref_rni_batch_sheet_no ? item.ref_rni_batch_sheet_no.split(",").map((v, idx) => (
//                                                                                         <div key={idx}>{v.trim()}</div>
//                                                                                     )) : "—"}</td> */}
//                                                                                     <td>
//                                                                                         {item.ref_vid ? item.ref_vid.split(",").map((v, idx) => (
//                                                                                             <div key={idx}>{v.trim()}</div>
//                                                                                         )) : "—"}
//                                                                                     </td>
//                                                                                     <td>
//                                                                                         {item.ref_trfid ? item.ref_trfid.split(",").map((v, idx) => (
//                                                                                             <div key={idx}>{v.trim()}</div>
//                                                                                         )) : "—"}
//                                                                                     </td>
//                                                                                     <td>
//                                                                                         {new Date(item.createdon).toLocaleString("en-GB", {
//                                                                                             day: "2-digit", month: "short", year: "numeric",
//                                                                                             hour: "2-digit", minute: "2-digit", hour12: true,
//                                                                                         }).replace(",", "").replace(/\s?(am|pm)/i, m => m.toUpperCase())}
//                                                                                     </td>
//                                                                                     <td className="text-center">
//                                                                                         {item.pdf_url ? (
//                                                                                             <span
//                                                                                                 title="View Batch Sheet PDF"
//                                                                                                 style={{ cursor: "pointer" }}
//                                                                                                 onClick={() => window.open(item.pdf_url, '_blank')}
//                                                                                             >
//                                                                                                 <FaFileAlt color="green" size={16} />
//                                                                                             </span>
//                                                                                         ) : "—"}
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             ))
//                                                                         ) : (
//                                                                             <tr>
//                                                                                 <td colSpan="5" className="text-center">No batch sheets found</td>
//                                                                             </tr>
//                                                                         )}
//                                                                     </tbody>
//                                                                 </table>
//                                                             </div>
//                                                             {filtered.length > BS_PAGE_SIZE && (
//                                                                 <CommonPagination
//                                                                     pageList={filtered}
//                                                                     currentPage={safePage}
//                                                                     itemsPerPage={BS_PAGE_SIZE}
//                                                                     setCurrentPage={setBatchSheetPage}
//                                                                 />
//                                                             )}
//                                                         </>
//                                                     );
//                                                 })()}
//                                             </div>
//                                             <div className="modal-footer p-2">
//                                                 <button type="button" className="btn btn-danger" onClick={() => setShowBatchSheetModal(false)}>Close</button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </>
//                         )}

//                         {filteredB2BTRFRegistrationtList.length > itemsPerPage ? (
//                             <CommonPagination
//                                 pageList={filteredB2BTRFRegistrationtList}
//                                 currentPage={currentPage}
//                                 itemsPerPage={itemsPerPage}
//                                 setCurrentPage={setCurrentPage}
//                             />
//                         ) : null}
//                     </div>
//                 </div>
//             </div >
//         </div >
//     );
// };

// export default TRFRegistrationListComponent;
